import '../App.scss';
import '../projects/Project.scss';
import {
  ALLOTMENT_IDS,
  PROJECT_TYPE_ALLOTMENT_ID,
  REFERENCE_TYPE_NAME,
  TEMPLATE_TYPE_NAME,
  TYPE_AIRPORT,
  TYPE_BBCA,
  TYPE_DATACENTER,
  TYPE_EPCM,
  TYPE_EXPLOITATION,
  TYPE_NOOCO,
  TYPE_OUTDOOR,
  TYPE_PROTOTYPE,
  TYPE_RE2020,
  TYPE_RENOVATION,
} from '../globalVariable/typeProject';
import {
  BBCA_TREATMENT_MODE_VALUES_KEY,
  BBCA_TREATMENT_MODE_VALUES_NAME,
} from '../models/ProjectDTO';

import { OptionType } from '../globalVariable/enumType';
import { Tooltip } from '@mui/material';
import { LOTS_IDS, TYPE_FICHE, ZONE_TYPES } from '../globalVariable/generalDefinitions';
import Energie from '../../assets/images/products/Energie.svg';
import InfoIcon from '@material-ui/icons/Info';
import React from 'react';
import Water from '../../assets/images/products/watersmall.png';
import customEquipmentIcon from '../../assets/images/equipments/customEquipment.png';
import formatNumber from '../services/mathematics/formatNumber';
import refurbishedIcon from '../../assets/images/equipments/refurbished.png';
import sanitizeHtml from 'sanitize-html';
import { GOOGLE_PROVIDER } from '../globalVariable/authVariable';
import { downloadData } from 'aws-amplify/storage';

import dayjs from 'dayjs';

import CFA from '../../assets/images/products/CFA.png';
import CFO from '../../assets/images/products/CFO.png';
import CloisonsPlafond from '../../assets/images/products/CloisonsPlafond.png';
import CVC from '../../assets/images/products/CVC.png';
import Déplacementintérieur from '../../assets/images/products/Déplacementintérieur.png';
import Façades from '../../assets/images/products/Façades.png';
import Infrastructure from '../../assets/images/products/Infrastructure.png';
import Menuiserieextérieure from '../../assets/images/products/Menuiserieextérieure.png';
import Peinture from '../../assets/images/products/Peinture.png';
import Plomberie from '../../assets/images/products/Plomberie.png';
import Terre from '../../assets/images/products/Terre.png';
import VRD from '../../assets/images/products/VRD.png';
import Superstructure from '../../assets/images/products/Superstructure.png';
import Couverture from '../../assets/images/products/Couverture.png';
import SystemesTriBagage from '../../assets/images/products/SystemesTriBagage.png';
import Réseaux from '../../assets/images/products/Réseaux.png';
import SecuriteIncendie from '../../assets/images/products/SecuriteIncendie.svg';
import TransportsEngins from '../../assets/images/products/TransportsEngins.svg';

import EclairagesPublic from '../../assets/images/products/EclairagesPublic.png';
import IRVE from '../../assets/images/products/IRVE.svg';
import PIF from '../../assets/images/products/PIF.svg';
import OuvrageArt from '../../assets/images/products/OuvrageArt.svg';
import Fluide from '../../assets/images/products/Fluide.svg';
import EnergieSimplifiee from '../../assets/images/products/EnergieSimplifiee.svg';
import defaultPic from '../../assets/images/products/default.png';
import { SEARCH_GROUP_OPTION_VALUES } from '../globalVariable/searchGroupType';

export const REFERENCE_SURFACE_TAG = {
  zone: 'zone',
  building: 'building',
  project: 'totalProject',
};

export const additionCarbonIndicators = (isIndicator) => {
  let emissionUnitaire = 0;

  if (isIndicator.SheetIndex.AProd) {
    emissionUnitaire += isIndicator.SheetIndex.AProd;
  } else {
    emissionUnitaire +=
      isIndicator.SheetIndex.A1 +
      isIndicator.SheetIndex.A2 +
      isIndicator.SheetIndex.A3;
  }

  if (isIndicator.SheetIndex.AEdif) {
    emissionUnitaire += isIndicator.SheetIndex.AEdif;
  } else {
    emissionUnitaire += isIndicator.SheetIndex.A4 + isIndicator.SheetIndex.A5;
  }

  // if (isUsageComputed) {

  //   if (isIndicator.SheetIndex.B) {

  //     emissionUnitaire += isIndicator.SheetIndex.B;

  //   } else {

  //     if (isIndicator.SheetIndex.BMaint) {

  //       emissionUnitaire += isIndicator.SheetIndex.BMaint;

  //     } else {

  //       emissionUnitaire += isIndicator.SheetIndex.B1 + isIndicator.SheetIndex.B2 + isIndicator.SheetIndex.B3 + isIndicator.SheetIndex.B4 + isIndicator.SheetIndex.B5;

  //     }

  //     // if (isIndicator.SheetIndex.BOp) {

  //     //   emissionUnitaire += isIndicator.SheetIndex.BOp;

  //     // } else {

  //     //   emissionUnitaire += isIndicator.SheetIndex.B6 + isIndicator.SheetIndex.B7;

  //     // }

  //   }

  // }

  if (isIndicator.SheetIndex.C) {
    emissionUnitaire += isIndicator.SheetIndex.C;
  } else {
    emissionUnitaire +=
      isIndicator.SheetIndex.C1 +
      isIndicator.SheetIndex.C2 +
      isIndicator.SheetIndex.C3 +
      isIndicator.SheetIndex.C4;
  }

  if (isIndicator.SheetIndex.D) {
    emissionUnitaire += isIndicator.SheetIndex.D;
  }

  if (emissionUnitaire === 0 || emissionUnitaire === isIndicator.SheetIndex.D) {
    emissionUnitaire = isIndicator.SheetIndex.TOTAL + isIndicator.SheetIndex.D;
  }

  return emissionUnitaire;
};

export const getAllZones = (currentProject, row) => {
  if (currentProject.Zones[0]) {
    if (!row) {
      const isParcel =
        currentProject.Zones[0].type === 'plot' ? currentProject.Zones[0] : null;

      const filteredBuilding = isParcel
        ? currentProject.Zones[0].Zones.filter((elem) => elem.type === 'building')
        : currentProject.Zones.filter((elem) => elem.type === 'building');

      let allNames = isParcel ? [isParcel] : [];

      filteredBuilding.forEach((elem) => {
        elem.Zones.forEach((current) => {
          if (current.type !== 'buildingSite') {
            current = { ...current, buildingName: elem.name };

            allNames = [...allNames, current];
          }
        });
      });

      return allNames;
    } else {
      let zone = [];

      if (currentProject.Zones[0].type === 'plot') {
        const isZone = currentProject.Zones[0].ProjectSheets.find(
          (elem) =>
            elem.SheetId === row.id &&
            row.ProjectSheet.ZoneId === currentProject.Zones[0].id &&
            elem.quantity == row.ProjectSheet.quantity
        );

        if (isZone) zone = [...zone, currentProject.Zones[0]];

        if (!zone.length > 0) {
          currentProject.Zones[0].Zones.forEach((el) => {
            if (el.type === 'buildingSite') {
              const isZone = el.ProjectSheets.find(
                (ele) => ele.SheetId == row.id && row.ProjectSheet.ZoneId === el.id
              );

              currentProject.Zones[0] = {
                ...currentProject.Zones[0],
                isBuildingSite: true,
              };

              if (isZone) zone = [...zone, currentProject.Zones[0]];
            }

            el.Zones.forEach((currentZone) => {
              const isZone = currentZone.ProjectSheets.find(
                (ele) =>
                  ele.SheetId == row.id &&
                  row.ProjectSheet.ZoneId === currentZone.id &&
                  ele.quantity == row.ProjectSheet.quantity
              );

              if (isZone) {
                currentZone = { ...currentZone, buildingName: el.name };
                zone = [...zone, currentZone];
              }

              currentZone.Zones.forEach((sousZone) => {
                const isZone = sousZone.ProjectSheets.find(
                  (ele) =>
                    ele.SheetId == row.id &&
                    row.ProjectSheet.ZoneId === sousZone.id &&
                    ele.quantity == row.ProjectSheet.quantity
                );

                currentZone = {
                  ...currentZone,
                  buildingName: el.name,
                  isBuildingSite: true,
                };

                if (isZone) zone = [...zone, currentZone];
              });
            });
          });
        }
      } else {
        currentProject.Zones.forEach((el) => {
          if (el.type === 'buildingSite') {
            const isZone = el.ProjectSheets.find((ele) => ele.SheetId == row.id);

            if (isZone) zone = [...zone, el];
          }

          el.Zones.forEach((currentZone) => {
            const isZone = currentZone.ProjectSheets.find(
              (ele) =>
                ele.SheetId == row.id &&
                row.ProjectSheet.ZoneId === currentZone.id &&
                ele.quantity == row.ProjectSheet.quantity
            );

            if (isZone) {
              currentZone = { ...currentZone, buildingName: el.name };
              zone = [...zone, currentZone];
            }

            currentZone.Zones.forEach((sousZone) => {
              const isZone = sousZone.ProjectSheets.find(
                (ele) =>
                  ele.SheetId == row.id &&
                  ele.ZoneId === sousZone.id &&
                  ele.quantity == row.ProjectSheet.quantity
              );

              if (isZone) {
                currentZone = {
                  ...currentZone,
                  buildingName: el.name,
                  isBuildingSite: true,
                };
                zone = [...zone, currentZone];
              }
            });
          });
        });
      }

      return zone;
    }
  }
};

export const sortById = (datas) => {
  return datas.sort((a, b) => a.originalRow - b.originalRow || a.id - b.id);
};

export const filterImportDatas = (filters, isArchivedRowsDisplayed, wholeData) => {
  let data = [];

  if (filters.length > 0) {
    for (let i = 0; i < filters.length; i++) {
      let newDatas;

      if (filters[i] !== 'error') {
        newDatas = wholeData.filter(
          (el) =>
            el.statusCode === filters[i] &&
            !el.ProjectImportElemCaracs?.find((el) => el.statusCode)
        );
      } else {
        newDatas = wholeData.filter(
          (el) =>
            el.isValid === false ||
            el.ProjectImportElemCaracs?.find((el) => el.statusCode) ||
            (el.statusCode !== 'Validated' && el.statusCode !== 'userValidated')
        );
      }

      data = [...data, ...newDatas];
    }
  }

  if (filters.length === 0 && wholeData) {
    data = [...wholeData];
  }

  return data
    .sort((a, b) => a.originalRow - b.originalRow)
    .filter((row) => (!isArchivedRowsDisplayed ? !row.isArchived : row.isArchived));
};

export const closest = (value, array, userCarac) => {
  let lo, hi, lower, higher;
  const length = array.length - 1;
  let numberValue = Number(value);
  let result = [];
  const caracId = userCarac.id;
  const caracName = userCarac.name;

  for (let index = length; index >= 0; index -= 1) {
    let carac = array[index].Caracs.find(
      (c) => c.id === caracId || c.name === caracName
    );

    if (!carac) {
      continue;
    }

    const caracValue = Number(carac.SheetCarac.value[0]);

    if (caracValue === numberValue) {
      result.push(array[index]);
      continue;
    }

    if (caracValue <= numberValue && (lo === undefined || lo < caracValue)) {
      lo = caracValue;
      lower = array[index];
    }

    if (caracValue >= numberValue && (hi === undefined || hi > caracValue)) {
      hi = caracValue;
      higher = array[index];
    }
  }

  if (lower) {
    result.push(lower);
  }

  if (!higher) {
    return result;
  }

  if ((higher && !lower) || higher.id !== lower.id) {
    result.push(higher);
  }

  return result;
};

export const recursiveNomenclatureInies = (datas, currentData) => {
  const childrens = datas.filter(
    (el) => el.Parent_Item_ID === currentData.Nomenclature_Item_ID
  );

  if (childrens.length > 0) {
    currentData = {
      ...currentData,
      children: childrens,
      value: currentData.Nomenclature_Item_ID,
      title: currentData.Nomenclature_Item_Name,
    };

    for (let i = 0; i < childrens.length; i++) {
      childrens[i] = {
        ...childrens[i],
        value: childrens[i].Nomenclature_Item_ID,
        title: childrens[i].Nomenclature_Item_Name,
      };

      if (childrens[i].Has_Children) {
        childrens[i] = recursiveNomenclatureInies(datas, childrens[i]);
      }
    }
  }

  return currentData;
};

export const createSetElems = (projectElems) => {
  let newList = [...projectElems];

  for (let i = 0; i < projectElems.length; i++) {
    if (
      newList.filter((elem) => elem.originalRow === projectElems[i].originalRow)
        .length > 1 &&
      projectElems[i].originalRow
    ) {
      newList = newList.filter(
        (elem) => elem.originalRow !== projectElems[i].originalRow
      );

      let allRowsToSet = projectElems.filter(
        (elem) => elem.originalRow === projectElems[i].originalRow
      );

      const newRow = {
        id: 'duplicate',
        name: allRowsToSet[0].name,
        originalRow: allRowsToSet[0].originalRow,
        originalQuantity: allRowsToSet[0].originalQuantity,
        originalUnit: allRowsToSet[0].originalUnit,
        originalName: allRowsToSet[0].originalName,
        ProjectElemsDuplicate: allRowsToSet,
        isArchived: allRowsToSet.find((el) => el.isArchived) ? true : false,
      };

      newList = [...newList, newRow];
    }
  }

  return newList;
};

export const findBreadcrumbChoices = (allots, allGroups, lot, zones) => {
  const choices = {
    fonction: [],
    categorie: [],
    materiel: [],
    type: [],
  };

  let levels = ['lot', 'fonction', 'categorie', 'materiel', 'type'];

  const recursiveFormatDataBreadcrumb = (
    parentNode,
    allots,
    choices,
    key,
    details
  ) => {
    let detail = { ...details, [levels[key]]: parentNode.name };

    let allNodes = allots
      .filter((node) => node.ParentId === parentNode.id)
      .map((el) => ({ ...el, click: 'enable', full: [detail] }));

    choices[levels[key + 1]] = [...choices[levels[key + 1]], ...allNodes];

    // choices[levels[key + 1]] = choices[levels[key + 1]].map((node) => {
    //   let fulls = [];

    //   choices[levels[key + 1]]
    //     .filter((el) => el.name === node.name)
    //     .map((el) => {
    //       fulls = [...fulls, ...el.full];
    //     });

    //   return {
    //     ...node,
    //     full: fulls,
    //   };
    // });

    if (!allNodes.find((el) => el.MasterDataEquipmentId)) {
      allNodes.map((nd) => {
        return recursiveFormatDataBreadcrumb(nd, allots, choices, key + 1, detail);
      });
    } else {
      return choices;
    }
  };

  let initNode = allots.find(
    (node) => node.name === lot && !node.ParentId && node.AllotmentId === 1
  );

  let iterator = 0;

  recursiveFormatDataBreadcrumb(initNode, allots, choices, iterator, {});

  // for (const [key] of Object.entries(choices)) {
  //   const values = allGroups.type.filter((el) => !el.isObsolete).map((el) => {
  //     if(el.fonction === 'Chauffage' || el.fonction === 'ECS' || el.fonction === 'Refroidissement')

  //       if(!zones.find((zone) => zone.IsConnectedToUrbanNetwork) && el.isConnectedToUrbanNetwork) {
  //         return;
  //       }

  //     if(el.lot === lot && !el.isObsolete) {
  //       return  {name: el[key], full: allGroups.type.filter((ele) => (ele[key] === el[key]) && (ele.lot === lot) && !ele.isObsolete), click: 'enable'};
  //     }
  //   });

  //   choices[key] = lodash.uniqBy(values,
  //     'name').filter((el) => el);
  // }

  return choices;
};

export const handleMdButtons = (
  currentMd,
  allGroups,
  currentAllotment,
  currentProject
) => {
  let datas = [];
  let coupable = [];
  let orderList = [];
  let links = [];

  if (currentMd && currentMd.Parent) {
    currentMd.Parent.forEach((parents) => {
      if (parents.ChildId) {
        const parent = allGroups.type.find(
          (md) => md.id === parents.ChildId && !md.isObsolete
        );

        if (parent) links = [...links, parent];
      }
    });
  }

  if (currentMd && currentMd.Child && currentMd.Child[0]) {
    const child = allGroups.type.filter(
      (md) =>
        md.Child[0] &&
        md.Child[0].ParentId === currentMd.Child[0].ParentId &&
        currentMd.id !== md.id &&
        !md.isObsolete
    );

    // need apologise for this...
    const parentObject = allGroups.type.filter(
      (md) => md.id === currentMd.Child[0].ParentId && !md.isObsolete
    );

    if (child || parentObject) {
      links = [...links, ...child, ...parentObject];
    }
  }

  datas = [currentMd];

  let allDatas = [
    currentMd,
    ...links.filter((el) => currentProject.Lots.find((lot) => lot.name === el.lot)),
  ];

  // const list = ['lot', 'fonction', 'categorie', 'materiel', 'type'];

  let allStructures = [];
  let linkBreadcrumb = [];

  if (currentMd && !currentMd.isObsolete) {
    allDatas.map((ele) => {
      let object = {};

      let node;

      if (!ele.AllotmentNodes) return;

      if (ele.AllotmentNodes.some((i) => i.AllotmentId === currentAllotment?.id)) {
        node = currentAllotment.AllotmentNodes.find(
          (el) =>
            el.id ===
            ele.AllotmentNodes.find((i) => i.AllotmentId === currentAllotment.id).id
        );
      } else {
        node = ele?.AllotmentNodes.find((i) => i.AllotmentId === 1);
      }

      object = { [node?.level]: node };

      allStructures = [
        ...allStructures,
        getAllNodes(node, object, currentAllotment),
      ];
    });

    for (let i = 0; i < allDatas.length; i++) {
      delete allDatas[i].labelLink;
    }

    let findIt;

    allStructures.map((struct, i) => {
      if (findIt || !allStructures[i + 1]) {
        return;
      }

      for (const [key, value] of Object.entries(struct)) {
        if (
          allStructures[i][key]['name'] !== allStructures[i + 1][key]['name'] ||
          allStructures[i][key]['name'] !==
            allStructures[allStructures.length - 1][key]['name']
        ) {
          for (let index = 0; index < allStructures.length; index++) {
            let currentName =
              currentAllotment.id === 2 && !allStructures[index][2]
                ? allStructures[index][key]?.name
                : currentAllotment.id === 2
                ? allStructures[index][2]?.name.slice(0, 4)
                : allStructures[index][key]?.name;

            allDatas[index].labelLink = currentName;

            const object = allDatas[index];

            object.labelLink =
              currentAllotment.id === 2
                ? allStructures[index][2]
                : allStructures[index][key];

            linkBreadcrumb = [...linkBreadcrumb, object];
          }

          findIt = allStructures[i][key];

          return;
        }
      }
    });
  }

  allDatas =
    allDatas.length === 1 ||
    allDatas.filter((el) => el.labelLink).length !== allDatas.length
      ? []
      : allDatas;

  // Remove all links which have same labelLink and check if its not the currentMD, it is pure sheet
  let formatDatas = [];

  for (let i = 0; i < allDatas.length; i++) {
    if (
      !allDatas.find(
        (el) =>
          el.labelLink.id === allDatas[i].labelLink.id && el.id !== allDatas[i].id
      )
    ) {
      formatDatas = [...formatDatas, allDatas[i]];
    } else if (
      !formatDatas.find((el) => el.labelLink.id === allDatas[i].labelLink.id)
    ) {
      formatDatas = [...formatDatas, allDatas[i]];
    }
  }

  return { allDatas: formatDatas, linkBreadcrumb };
};

export const getAllNodes = (node, object, currentAllotment) => {
  if (!currentAllotment) {
    return;
  }

  const parent = currentAllotment.AllotmentNodes.find(
    (el) => el.id === node?.ParentId
  );

  if (parent) {
    object = { ...object, [parent.level]: parent };

    if (parent?.ParentId) {
      return getAllNodes(parent, object, currentAllotment);
    } else {
      return object;
    }
  }
};

export const makeNamesForZone = (zones, zone, name) => {
  name.push(
    zone.type === 'buildingSite'
      ? '(Chantier)'
      : zone.type === 'building'
      ? `${zone.name} -`
      : ` ${zone.name} `
  );

  if (zone.ParentId && zone.type !== 'building') {
    return makeNamesForZone(
      zones,
      zones.find((el) => el.id === zone.ParentId),
      name
    );
  } else {
    return name.reverse().join('').trim();
  }
};

export const linkInBreadcrumb = (
  copyAllot,
  allGroups,
  searchValue,
  currentAllotment,
  flatAllotments,
  currentProject
) => {
  const currentMd = allGroups.type.find(
    (el) => el.id === searchValue.MasterDataEquipmentId
  );

  const potentialLink = handleAllotmentNodes(
    currentMd,
    currentAllotment,
    flatAllotments,
    currentProject
  );

  copyAllot = copyAllot.map((el) => {
    if (potentialLink.find((link) => link.id === el.id)) {
      return {
        ...el,
        link:
          potentialLink.filter((link) => link.id !== el.id).length > 0
            ? potentialLink.filter((link) => link.id !== el.id)
            : null,
      };
    }

    return el;
  });

  return copyAllot;
};

export const getYearFromDate = (date) => {
  let year = dayjs(date, 'DD/MM/YYYY').year();

  if (!year) {
    year = dayjs(date, 'YYYY/MM/DD').year();
  }

  return year;
};

export const formatViewCard = (list, viewMode) => {
  let datas = [];
  let current = [];

  if (viewMode === 'card') {
    for (let i = 0; list.length > i; i++) {
      if ((i + 1) % 3 === 0) {
        datas = [...datas, [...current, list[i]]];

        current = [];
      } else {
        current = [...current, list[i]];
      }
    }

    return list.length < 3 ? [list] : datas.filter((el) => el.length > 0);
  } else {
    if (Array.isArray(list[0])) {
      for (let i = 0; list.length > i; i++) {
        datas = [...datas, ...list[i]];
      }
    }

    return datas;
  }
};

export const putCountOnNode = (node, count) => {
  // console.log(node, count);

  if (node.id === count.AllotmentNodeId) {
    // console.log('on rentrer dans 1er if');
    node.count = count.count;
    node.icon = (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '55px', display: 'flex' }}>
          {(count.count.find((el) => el.type_fiche === 'PEP')?.count ||
            count.count.find((el) => el.type_fiche === 'FDES')?.count) && (
            <div className="circleBadge pepfdes">
              <span className="count-badge">
                {(count.count.find((el) => el.type_fiche === 'PEP')?.count || 0) +
                  (count.count.find((el) => el.type_fiche === 'FDES')?.count || 0)}
              </span>
            </div>
          )}
          {count.count.find((el) => el.type_fiche === 'DED')?.count && (
            <div className="circleBadge ded">
              <span className="count-badge">
                {count.count.find((el) => el.type_fiche === 'DED')?.count || 0}
              </span>
            </div>
          )}
          {count.count.find((el) => el.type_fiche === 'DEC')?.count && (
            <div className="circleBadge dec">
              <span className="count-badge">
                {count.count.find((el) => el.type_fiche === 'DEC')?.count || 0}
              </span>
            </div>
          )}
          {count.count.find((el) => el.type_fiche === 'FORFAIT')?.count && (
            <div className="circleBadge forfait">
              <span className="count-badge">
                {count.count.find((el) => el.type_fiche === 'FORFAIT')?.count || 0}
              </span>
            </div>
          )}
        </div>
        <div style={{ marginLeft: '40px' }}>
          {node.level === 0 && (
            <img
              style={{
                marginLeft: '5px',
                width: node.name === 'Eau' ? '22px' : '24px',
                height: '24px',
              }}
              src={
                node.name === 'Superstructure'
                  ? Superstructure
                  : node.name === 'Sécurité Incendie'
                  ? SecuriteIncendie
                  : node.name === 'Transports et engins'
                  ? TransportsEngins
                  : node.name === 'CFA'
                  ? CFA
                  : node.name === 'Menuiseries ext.'
                  ? Menuiserieextérieure
                  : node.name === 'Plomberie'
                  ? Plomberie
                  : node.name === 'Cloison-Plafond'
                  ? CloisonsPlafond
                  : node.name === 'Infrastructure'
                  ? Infrastructure
                  : node.name === 'CVC'
                  ? CVC
                  : node.name === 'CFO'
                  ? CFO
                  : node.name === 'Façades'
                  ? Façades
                  : node.name === 'VRD-Aménagement'
                  ? VRD
                  : node.name === 'Revêtements-Peintures'
                  ? Peinture
                  : node.name === 'Déplacement int.'
                  ? Déplacementintérieur
                  : node.name === 'Terre'
                  ? Terre
                  : node.name === 'Couverture-étanchéité'
                  ? Couverture
                  : node.name === 'Energie'
                  ? Energie
                  : node.name === 'Eau'
                  ? Water
                  : node.name === 'Réseaux'
                  ? Réseaux
                  : node.name === 'Système tri-bagages'
                  ? SystemesTriBagage
                  : node.name === 'Éclairage public-SLT'
                  ? EclairagesPublic
                  : node.name === "Ouvrage d'art"
                  ? OuvrageArt
                  : node.name === 'IRVE'
                  ? IRVE
                  : node.name === "Poste d'Inspection Filtrage"
                  ? PIF
                  : node.name === 'Energie simplifiée'
                  ? EnergieSimplifiee
                  : node.name === 'Fluides'
                  ? Fluide
                  : defaultPic
              }
              alt=""
            />
          )}
        </div>
      </div>
    );

    return node;
  } else {
    if (node.children) {
      node.children.forEach((child) => {
        return putCountOnNode(child, count);
      });
    }
  }
};

export const checkStatusLine = (line, oldLine, bads, waits, goods, archived) => {
  let baddies = bads;
  let waitings = waits;
  let valids = goods;

  if (oldLine.isArchived) {
    archived -= 1;
  } else if (
    (oldLine.statusCode !== 'userValidated' && oldLine.statusCode !== 'Validated') ||
    oldLine.ProjectImportElemCaracs?.find((el) => el.statusCode)
  ) {
    baddies -= 1;
  } else if (oldLine.statusCode === 'Validated') {
    waitings -= 1;
  } else if (oldLine.statusCode === 'userValidated') {
    valids -= 1;
  }
  if (line.isArchived) {
    archived += 1;
  } else if (
    (line.statusCode !== 'userValidated' && line.statusCode !== 'Validated') ||
    (line.ProjectImportElemCaracs?.find((el) => el.statusCode) && !line.isArchived)
  ) {
    baddies += 1;
  } else if (line.statusCode === 'Validated' && !line.isArchived) {
    waitings += 1;
  } else if (line.statusCode === 'userValidated' && !line.isArchived) {
    valids += 1;
  }

  return { bads: baddies, waits: waitings, valids: valids, archivedLines: archived };
};

export const gaugeEPCM = (valueToCompare, projectIc) => {
  let key = valueToCompare === 'IcProjet' ? 'Eges_max' : 'Eges_pce_max';

  if (
    projectIc[`${key}1`] > projectIc[valueToCompare] &&
    projectIc[`${key}2`] > projectIc[valueToCompare]
  ) {
    return 100;
  } else if (
    projectIc[`${key}1`] > projectIc[valueToCompare] &&
    projectIc[`${key}2`] < projectIc[valueToCompare]
  ) {
    return 60;
  } else {
    return 20;
  }
};

export const displayResultImpact = (value, project, ic, onTab) => {
  return `${formatNumber(
    project.refUnit === 'm²' ? value / project.area : value
  )} ${ic}${project.refUnit === 'm²' ? '/m²' : ''}`;
};

export const getReferenceTypeNameFromProjectType = (projectType) => {
  switch (projectType) {
    case TYPE_RE2020:
      return REFERENCE_TYPE_NAME.RE2020;
    case TYPE_EPCM:
      return REFERENCE_TYPE_NAME.EPCM;
    default:
      return null;
  }
};

export const returnProjectTypeTitleFromTemplateType = (projectType) => {
  switch (projectType) {
    case TYPE_NOOCO:
      return 'Mode écoconception';
    case TYPE_RE2020:
      return 'Mode RE2020';
    case TYPE_EPCM:
      return 'Mode E+C-';
    //TODO A VERIFIER // BRANCH BBCA  Rénovation libre instead?
    case TYPE_RENOVATION:
      return 'Rénovation libre';
    case TYPE_EXPLOITATION:
      return 'Exploitation';
    case TYPE_AIRPORT:
      return 'Aéroport';
    case TYPE_DATACENTER:
      return 'Datacenter';
    case TYPE_PROTOTYPE:
      return 'Prototype';
    case TYPE_OUTDOOR:
      return 'Infrastructure extérieure';
    //TODO A VERIFIER // BRANCH BBCA
    case TYPE_BBCA:
      return 'BBCA Rénovation';
    default:
      return '';
  }
};

export const returnProjectTypeFromProjectTypeTitle = (input) => {
  switch (input) {
    case 'Mode écoconception':
      return TYPE_NOOCO;
    case 'Mode RE2020':
      return TYPE_RE2020;
    case 'Mode E+C-':
      return TYPE_EPCM;
    //TODO A VERIFIER // BRANCH BBCA  Rénovation libre instead?
    case 'Rénovation libre':
      return TYPE_RENOVATION;
    case 'Exploitation':
      return TYPE_EXPLOITATION;
    case 'Aéroport':
      return TYPE_AIRPORT;
    case 'Datacenter':
      return TYPE_DATACENTER;
    case 'Infrastructure extérieure':
      return TYPE_OUTDOOR;
    case 'Prototype':
      return TYPE_PROTOTYPE;
    //TODO A VERIFIER // BRANCH BBCA
    case 'BBCA Rénovation':
      return TYPE_BBCA;
    default:
      return '';
  }
};

export const filterByTemplateType = (array, currentProject) => {
  return array.filter((el) => {
    if (
      (currentProject.templateType === TYPE_EPCM &&
        !el.referenceType.includes(REFERENCE_TYPE_NAME.EPCM)) ||
      (currentProject.templateType !== TYPE_EPCM &&
        el.referenceType &&
        el.referenceType.length === 1 &&
        el.referenceType.includes(REFERENCE_TYPE_NAME.EPCM))
    ) {
      return false;
    }

    return true;
  });
};

export const handleAllotmentNodes = (
  md,
  currentAllotment,
  allotments,
  currentProject,
  listType
) => {
  if (!currentAllotment) {
    return;
  }

  const allotmentName =
    currentAllotment.id === 2 ? 'Re2020AllotmentNodeId' : 'EpcmAllotmentNodeId';

  const nodeWithSameConfigMd = allotments.filter(
    (el) =>
      el.AllotmentId === 1 && el.MasterDataEquipmentId === md?.id && !el.isObsolete
  );

  let parentNodes = [];

  if (currentAllotment.id !== 1) {
    nodeWithSameConfigMd.forEach((nodeNooco) => {
      let objectReFormat = {
        ...allotments.find((el) => el.id === nodeNooco[allotmentName]),
        noocoAllotId: nodeNooco.id,
        color: nodeNooco.color,
        MasterDataEquipmentId: md.id,
      };

      let noocoAllots = findParentNode(nodeNooco, allotments, [], []);

      let isAvailable = currentProject.Lots.find((lot) =>
        noocoAllots.find((el) => el.id === lot.id)
      );

      if (!parentNodes.find((el) => el.id === objectReFormat.id) && isAvailable) {
        parentNodes = [
          ...parentNodes,
          { ...objectReFormat, details: [objectReFormat, nodeNooco] },
        ];
      }
    });
  } else {
    nodeWithSameConfigMd.forEach((node) => {
      let details = [];

      parentNodes = findParentNode(
        node,
        currentAllotment.AllotmentNodes,
        parentNodes,
        details
      );
    });
  }

  if (currentProject) {
    parentNodes =
      currentAllotment.id === 1 && currentProject.Lots
        ? parentNodes.filter((el) =>
            currentProject.Lots.find((lot) => lot.id === el.id)
          )
        : parentNodes;
  }

  return parentNodes.filter((el) => !el.isObsolete)
  .map((node) => ({ ...node, label: node.name, value: node.id }));
};

/**
 * Returns an array of the parentAllotments for the given project types
 * that are available to the user.
 *
 * @param {number[]} projectsTypeAvailableIds - An array of project type IDs that are available to the user. could state.projects.templateTypeAvailableIds
 * @param {object[]} projectTypes - An array of project types. Could state.projects.allGroups.projectTypes
 * @param {object[]} allotmentNodes - An array of allotment nodes. Could state.projects.allGroups.flatAlloments or state.projects.allGroups.allotments...
 * @returns {object[]} An array of allotment node objects that are parents of the project types available to the user.
 */
export const parentAllotmentNodesOfTypeProjectsUserRight = (
  projectsTypeAvailableIds,
  projectTypes,
  allotmentNodes
) => {
  function isInProjectsTypeAvailableIds(id) {
    return projectsTypeAvailableIds.includes(id);
  }

  const allotmentNodesObject = projectTypes
    .filter((projectType) => isInProjectsTypeAvailableIds(projectType.id))
    .reduce((accumulator, projectType) => {
      projectType.AllotmentNodes.forEach((node) => {
        if (!accumulator[node.id]) {
          accumulator[node.id] = node;
        }
      });

      return accumulator;
    }, {});

  const allotmentNodesIds = Object.keys(allotmentNodesObject).map(Number);

  const allotmentNodesArray = allotmentNodes.filter((node) =>
    allotmentNodesIds.includes(node.id)
  );

  return allotmentNodesArray;
};

/**
 * Finds child allotmentNodes for the given parentAllotmentNodes, excluding those with isObsolete set to true.
 *
 * @param {Object[]} parentAllotmentNodes - An array of objects representing the parentAllotmentNodes.
 * @param {Object[]} allotmentNodes - An array of objects representing the allotmentNodes.
 * @returns {Object} An object containing arrays for each level (1, 2, 3, 4) with the corresponding allotmentNodes.
 */
export const findChildrenNodes = (parentAllotmentNodes, allotmentNodes) => {
  const result = {
    1: [],
    2: [],
    3: [],
    4: [],
  };

  function recursiveSearch(currentParentId, level) {
    if (level > 4) {
      return;
    }

    const children = allotmentNodes.filter(
      (node) =>
        node.ParentId === currentParentId && node.level === level && !node.isObsolete
    );

    if (children.length > 0) {
      result[level].push(...children);
      children.forEach((child) => {
        recursiveSearch(child.id, level + 1);
      });
    }
  }

  parentAllotmentNodes.forEach((parentNode) => {
    if (!parentNode.isObsolete) {
      recursiveSearch(parentNode.id, 1);
    }
  });

  return result;
};

/**
 * Recursive function to find the parent AllotmentNode of a given AllotmentNode.
 * Final result is at the root of the object, and the whole parent tree is also provided
 * in the form of an array of AllotmentNodes in the details property.
 * The order inside the array is not related to the tree level, hence a find should be used
 * to fetch the desired level
 *
 * Also for whatever reason result in returned in an array (even though this is useless...)
 *
 * @returns {AllotmentNode[]} - parentAllotment of level === 0 in an array.
 */
export const findParentNode = (node, allotmentNodes, result, details) => {
	if (node?.ParentId) {
	  let	parent = allotmentNodes.find((el) => el.id === node.ParentId);

    details = [...details, parent];

    if (node.level === 4) {
      details = [...details, node];
    }

    return findParentNode(parent, allotmentNodes, result, details);
  } else {
    return [...result, { ...node, details }];
  }
};

// Rofl... those two functions should be merged ffs
export const findParentNodeWithSelectLevel = (
  node,
  allotmentNodes,
  level,
  result,
  details
) => {
  if (node.level > level) {
    let parent = allotmentNodes.find((el) => el.id === node.ParentId);

    details = [...details, parent];

    if (node.level === 4) {
      details = [...details, node];
    }

    return findParentNodeWithSelectLevel(
      parent,
      allotmentNodes,
      level,
      result,
      details
    );
  } else {
    // console.log('return',
    //   [...result, { ...node, details }] );
    // console.log('node&detail',
    //   { ...node, details }.name);

    return [...result, { ...node, details }];
  }
};

export const findChildrenCompany = (parentNodeId, children, res) => {
  children = children.map((el) => {
    if (parentNodeId === el.id) {
      return {
        ...el,
        showChildren: true,
        height: el.height + 210 * [...el.children, ...res.data].length,
        children: [
          ...el.children,
          ...res.data.map((el) => ({
            ...el,
            height: 210,
            width: el.width - 5,
            children: [],
          })),
        ],
      };
    } else if (el.children && el.children.length > 0) {
      return findChildrenCompany(parentNodeId, el.children, res);
    } else {
      return el;
    }
  });

  return children;
};

export const updateShowChildren = (array, id, bool) => {
  if (!bool) {
    return array.map((obj) => {
      if (obj.id === id) {
        return { ...obj, showChildren: false, height: 210 };
      } else if (obj.children) {
        const result = updateShowChildren(obj.children, id, false);

        if (result) {
          return { ...obj, children: result };
        }
      }

      return obj;
    });
  } else {
    return array.map((obj) => {
      if (obj.id === id) {
        return { ...obj, showChildren: true, height: 210 * obj.children.length };
      } else if (obj.children) {
        const result = updateShowChildren(obj.children, id, true);

        if (result) {
          return { ...obj, children: result };
        }
      }

      return obj;
    });
  }
};

export const dynamicHeightCompanyCard = (company, res, parentNodeId) => {
  if (company.children && company.children.length > 0) {
    // company.children = findChildrenCompany(rights.parentNodeId,
    //   company.children,

    let heightToAdd = 0;

    //   res);
    company.children = company.children.map((el) => {
      if (parentNodeId === el.id) {
        heightToAdd = el.height + 210 * [...el.children, ...res.data].length;

        return {
          ...el,
          showChildren: true,
          height: heightToAdd,
          children: [
            ...el.children,
            ...res.data.map((ele) => ({
              ...ele,
              height: 210,
              width: el.width - 5,
              depth : el.depth + 2,
              children: [],
            })),
          ],
        };
      } else {
        if (el.children) {
          return dynamicHeightCompanyCard(el, res, parentNodeId);
        }

        return el;
      }
    });

    company.height = company.height + heightToAdd;

    return company;
  }

  return company;
};

export const recursiveSeekAndUpdateObjectById = (array, id, update) => {
  return array.map((objet) => {
    if (objet.id === id) {
      if (update['isAdmin']) {
        return {
          ...objet,
          adminCount: update['isAdmin'].isAdmin
            ? objet.adminCount + 1
            : objet.adminCount - 1,
          users: objet.users.map((el) =>
            el.id === update['isAdmin'].id
              ? { ...el, isAdmin: update['isAdmin'].isAdmin }
              : el
          ),
        };
      } else if (update['addCount']) {
        return {
          ...objet,
          freeLicenseCount: objet.freeLicenseCount.map((el) =>
            el.licenseType === update['addCount']
              ? { ...el, count: (el.count += 1) }
              : el
          ),
        };
      } else if (update['removeCount']) {
        return {
          ...objet,
          freeLicenseCount: objet.freeLicenseCount.map((el) =>
            el.licenseType === update['removeCount']
              ? { ...el, count: (el.count -= 1) }
              : el
          ),
        };
      } else if (update['contract']) {
        return {
          ...objet,
          contract: {
            ...objet.contract,
            endDate: update['contract'][0].endDate,
            startDate: update['contract'][0].startDate,
          },
        };
      }

      return { ...objet, ...update };
    } else if (objet.children && objet.children.length > 0) {
      return {
        ...objet,
        children: recursiveSeekAndUpdateObjectById(objet.children, id, update),
      };
    } else {
      return objet;
    }
  });
};

export const findMdByAllotmentNodeId = (AllotmentNodeId, allNodes, allMds) => {
  const node = allNodes.find((el) => el.id === AllotmentNodeId);

  return allMds.find((el) => el.id === node.MasterDataEquipmentId);
};

/**
 * Returns the masterData of the given AllotmentNode.
 *
 * @param {MasterDataEquipment[]} allMasterDatas - An array of masterDatas.
 * @param {AllotmentNodeDTO} AllotmentNode - An AllotmentNode.
 * @returns {MasterDataEquipment} - A masterData object
 */
export const findMdFromAllotmentNode = (allMasterDatas, AllotmentNode) => {
  return allMasterDatas.find((el) => el.id === AllotmentNode.MasterDataEquipmentId);
};

/**
 *Return array of masterDatas whose parent AllotmentNodes have names included or excluded based on the value of the 'keepOrRemoveParent' argument, from an array of AllotmentNode objects and an array of masterData objects.
 *
 * @param {AllotmentNodeDTO[]} allAllotmentNodes - An array of AllotmentNodeDTO objects.
 * @param {MasterDataEquipment[]} allMasterDatas - An array of masterData objects.
 * @param {string[]} parentNamesToFilter - An array of parent AllotmentNode names to include or exclude.
 * @param {'keep' | 'remove'} keepOrRemoveParent - A string indicating whether to include or exclude AllotmentNodes based on their parent node names.
 * @returns {MasterDataEquipment[]} - All masterData objects whose parentAllotmentNodes have names included or excluded based on the value of the 'keepOrRemoveParent' argument.
 */
export const findMdsFromFilteredParentAllotmentNodes = (
  allAllotmentNodes,
  allMasterDatas,
  parentNamesToFilter,
  keepOrRemoveParent
) => {
  let mdsFiltered = [];
  const childAllotmentNodes = findAllChildrenNodes(allAllotmentNodes);

  childAllotmentNodes.forEach((childAllotmentNode) => {
    const parentAllotmentNode = findParentNode(
      childAllotmentNode,
      allAllotmentNodes,
      [],
      []
    );

    if (keepOrRemoveParent === 'keep') {
      if (parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
        mdsFiltered.push(
          findMdFromAllotmentNode(allMasterDatas, childAllotmentNode)
        );
      }
    } else if (keepOrRemoveParent === 'remove') {
      if (!parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
        const masterDataFound = findMdFromAllotmentNode(
          allMasterDatas,
          childAllotmentNode
        );

        masterDataFound.name = childAllotmentNode.name;

        mdsFiltered.push(masterDataFound);
      }
    }
  });

  mdsFiltered.sort((a, b) => (a.name > b.name ? 1 : -1));

  return mdsFiltered;
};

/**
 *Return array of AllotmentNodesChildren whose parentAllotmentNodes have names included or excluded based on the value of the 'keepOrRemoveParent' argument,
 *
 * @param {AllotmentNodeDTO[]} allAllotmentNodes - An array of AllotmentNodeDTO objects.
 * @param {string[]} parentNamesToFilter - An array of parentAllotmentNode.names to include or exclude.
 * @param {'keep' | 'remove'} keepOrRemoveParent - A string indicating whether to include or exclude AllotmentNodes based on their parent node names.
 * @returns {AllotmentNodeDTO[]} - All AllotmentNodes objects whose parentAllotmentNodes have names included or excluded based on the value of the 'keepOrRemoveParent' argument.
 */
export const findAllAllotmentNodeChildrenFromFilteredParentAllotmentNodes = (
  allAllotmentNodes,
  parentNamesToFilter,
  keepOrRemoveParent
) => {
  let AllotmentNodesFiltered = [];
  const childAllotmentNodes = findAllChildrenNodes(allAllotmentNodes);

  childAllotmentNodes.forEach((childAllotmentNode) => {
    const parentAllotmentNode = findParentNode(
      childAllotmentNode,
      allAllotmentNodes,
      [],
      []
    );

    if (keepOrRemoveParent === 'keep') {
      if (parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
        AllotmentNodesFiltered.push(childAllotmentNode);
      }
    } else if (keepOrRemoveParent === 'remove') {
      if (!parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
        AllotmentNodesFiltered.push(childAllotmentNode);
      }
    }
  });

  AllotmentNodesFiltered.sort((a, b) => (a.name > b.name ? 1 : -1));

  return AllotmentNodesFiltered;
};

export const findAllAllotmentNodeChildrenFromFilteredParentAllotmentNodesSelectedLevel =
  (allAllotmentNodes, parentNamesToFilter, level, keepOrRemoveParent) => {
    let AllotmentNodesFiltered = [];
    const childAllotmentNodes = findAllChildrenNodesWithObsolete(allAllotmentNodes);

    childAllotmentNodes.forEach((childAllotmentNode) => {
      const parentAllotmentNode = findParentNodeWithSelectLevel(
        childAllotmentNode,
        allAllotmentNodes,
        level,
        [],
        []
      );

      // console.log('parentAllotmentNode[0].name',
      //   parentAllotmentNode[0].name);
      // if (parentAllotmentNode[0].name === 'Produits non couverts') {
      //   console.log('parentAllotmentNode[0].name',
      //     parentAllotmentNode[0].name,
      //     childAllotmentNode);
      // }
      if (keepOrRemoveParent === 'keep') {
        if (parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
          AllotmentNodesFiltered.push(childAllotmentNode);
        }
      } else if (keepOrRemoveParent === 'remove') {
        if (!parentNamesToFilter.includes(parentAllotmentNode[0].name)) {
          AllotmentNodesFiltered.push(childAllotmentNode);
        }
      }
    });

    AllotmentNodesFiltered.sort((a, b) => (a.name > b.name ? 1 : -1));

    return AllotmentNodesFiltered;
  };

/**
 * This function takes an array of AllotmentNodeDTO objects and returns an array of all child AllotmentNodeDTOs that are not obsolete and have a defined MasterDataEquipmentId.
 *
 * @param {AllotmentNodeDTO[]} AllotmentNodes - An array of AllotmentNodeDTO objects to filter.
 * @returns {AllotmentNodeDTO[]} - An array of all child AllotmentNodeDTOs that are not obsolete and have a defined MasterDataEquipmentId
 */
export const findAllChildrenNodes = (AllotmentNodes) => {
  return AllotmentNodes.filter((el) => el.MasterDataEquipmentId && !el.isObsolete);
};

export const findAllChildrenNodesWithObsolete = (AllotmentNodes) => {
  return AllotmentNodes.filter((el) => el.MasterDataEquipmentId);
};

export const filterNodesByProjectType = (nodes, projectType, mds) => {
  return nodes
    .filter((el) => !el.isObsolete)
    .map((node) => {
      if (node.MasterDataEquipmentId) {
        const md = findMdByAllotmentNodeId(node.id, nodes, mds);

        const referenceTypeFromCurrentProject =
          projectType === TYPE_EPCM
            ? REFERENCE_TYPE_NAME.EPCM
            : REFERENCE_TYPE_NAME.RE2020 || null;

        if (md.referenceType.includes(referenceTypeFromCurrentProject)) {
          return node;
        }
      } else {
        return node;
      }
    })
    .filter((el) => el);
};

export const findLotFromAllotmentNode = (
  allAllotmentNodes,
  AllotmentNode,
  targetLevel = 0
) => {
  let level = AllotmentNode.level;
  let parent = AllotmentNode;

  while (level > targetLevel) {
    parent = allAllotmentNodes.find((el) => el.id === parent.ParentId);
    level = parent.level;
  }

  return parent;
};

// handle to accept only numbers, coma, and point
export const handleKeyPress = (e) => {
  const key = e.key;
  const regex = /^[0-9,.]+$/;

  if (
    !regex.test(key) &&
    !['Backspace', 'Delete'].includes(e.key) &&
    typeof e.preventDefault === 'function'
  ) {
    e.preventDefault();
  }
};

export const handlePaste = (event) => {
  const pastedText = event.clipboardData.getData('text');

  const regex = /^[0-9,.-]*$/;

  if (!regex.test(pastedText) && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
};

export const getAllotmentId = (projectType) => {
  const projectTypeKey = Object.keys(TEMPLATE_TYPE_NAME).find(
    (key) => TEMPLATE_TYPE_NAME[key] === projectType
  );

  return PROJECT_TYPE_ALLOTMENT_ID[projectTypeKey];
};

export const returnAllMdsInProject = (sheets, allMds) => {
  let mds = [];

  sheets.forEach((sheet) => {
    let mdId = sheet.AllotmentNodes.find(
      (node) => node.MasterDataEquipmentId
    )?.MasterDataEquipmentId;

    if (mdId && !mds.find((md) => md.id === mdId)) {
      mds = [...mds, allMds.find((md) => md.id === mdId)];
    }
  });

  return mds;
};

export const findNodeByCurrentAllotment = (
  allAllotmentNodes,
  certificationKey,
  nodeSearchValue
) => {
  return allAllotmentNodes.find(
    (node) => node.id === nodeSearchValue[certificationKey]
  );
};

export const checkIfNodeCanBeAddedInProject = (
  node,
  currentProject,
  allAllotments
) => {
  let parentNode = findParentNode(node, allAllotments, [], []);

  if (currentProject.Lots.find((lot, i) => lot.id === parentNode[0].id)) {
    return true;
  } else {
    return false;
  }
};

export const checkIfForfaitBlocksEquipmentCreation = (
  projectSheets,
  currentProject,
  currentZone,
  zones,
  selectedAllotmentNode,
  lisOfAllAllotmentNodes,
  selectedCertifiedLot
) => {
  let projectSheetAllotmentName = '';
  let forfaitLotAndSousLot = '';
  let forfaitSheetName = '';

  const equipmentCreationIsBlocked = projectSheets?.some((projectSheet) => {
    const sheet = currentProject.Sheets.find(
      (sheet) => sheet.id === projectSheet.SheetId
    );

    if (sheet && sheet.type_fiche === 'FORFAIT') {
      forfaitSheetName = sheet.name;
      forfaitLotAndSousLot = extractForfaitLotAndSousLot(forfaitSheetName);

      projectSheetAllotmentName = extractProjectSheetAllotmentName(
        currentProject.templateType,
        selectedAllotmentNode,
        lisOfAllAllotmentNodes,
        selectedCertifiedLot
      );

      if (projectSheetAllotmentName?.includes(forfaitLotAndSousLot)) {
        return true;
      }
    }
  });

  let errorMessage = '';

  if (equipmentCreationIsBlocked) {
    errorMessage = `Merci de supprimer le forfait du ${
      forfaitSheetName.includes('Sous-lot')
        ? `sous-lot `
        : `lot ` + `${forfaitLotAndSousLot}`
    } attaché à la ${currentZone.name} du ${
      zones.find((el) => el.id === currentZone.ParentId).name
    } afin de pouvoir ajouter des équipements / matériaux`;
  }

  return [equipmentCreationIsBlocked, errorMessage];
};

export const extractForfaitLotAndSousLot = (sheetName) => {
  let numberValue = sheetName
    .replace('[RE2020]', '')
    .match('([0-9]{1,2})(.[0-9]{1})?');

  if (numberValue.length >= 1) {
    return numberValue[0];
  }

  return null;
};

export const extractProjectSheetAllotmentName = (
  templateType,
  selectedAllotmentNode,
  lisOfAllAllotmentNodes,
  selectedCertifiedLot
) => {
  if (selectedCertifiedLot) {
    return selectedCertifiedLot.name;
  }

  const allotmentNodeKey =
    templateType === TYPE_EPCM ? 'EpcmAllotmentNodeId' : 'Re2020AllotmentNodeId';
  const nodeTemplateType =
    selectedAllotmentNode?.AllotmentId === 1
      ? lisOfAllAllotmentNodes.find(
          (node) => node.id === selectedAllotmentNode[allotmentNodeKey]
        )
      : selectedAllotmentNode;

  return nodeTemplateType?.name;
};

export const findAllotmentNodesForNewBundle = (newBundleWithoutAllotmentNodes) => {
  let nodesNoocoFromBundleEquipment = [];

  newBundleWithoutAllotmentNodes.ProjectSheets.forEach((ps) => {
    nodesNoocoFromBundleEquipment = [
      ...nodesNoocoFromBundleEquipment,
      ps.AllotmentNodes.find((an) => an.AllotmentId === 1),
    ];
  });

  newBundleWithoutAllotmentNodes.AllotmentNodes = nodesNoocoFromBundleEquipment;
  newBundleWithoutAllotmentNodes.unit = newBundleWithoutAllotmentNodes.Unit?.name;

  return newBundleWithoutAllotmentNodes;
};

export const sortFilterSousLot = (array) => {
  return array.sort((a, b) => {
    // Check if the name starts with a number
    const aStartsWithNumber = Number(a.name.split('.')[0]);
    const bStartsWithNumber = Number(b.name.split('.')[0]);

    if (aStartsWithNumber && !bStartsWithNumber) {
      return -1;
    }
    if (!aStartsWithNumber && bStartsWithNumber) {
      return 1;
    }

    if (aStartsWithNumber && bStartsWithNumber) {
      if (aStartsWithNumber !== bStartsWithNumber) {
        return aStartsWithNumber - bStartsWithNumber;
      }
    }

    // If both names start with a number or both don't, sort by name in ascending order
    return a.name.localeCompare(b.name);
  });
};

export const sortByIniesUpdate = (array) => {
  return array.sort((teamA, teamB) => {
    return (
      teamB.isProductDisabled - teamA.isProductDisabled ||
      teamB.isDisabled - teamA.isDisabled
    );
  });
};

export const isProjectCertified = (projectTemplateType) => {
  return (
    projectTemplateType === TYPE_EPCM ||
    projectTemplateType === TYPE_RE2020 ||
    projectTemplateType === TYPE_BBCA
  );
};

export const returnLotIcon = (lotId) => {
  switch (lotId) {
    case LOTS_IDS.CFA:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 45H27V54H33V45H39V54H45V45H51V54H57V27H45V18H27V27H15V54H21V45ZM13.14 9H58.89C59.8262 8.99999 60.7532 9.18489 61.6178 9.54407C62.4824 9.90326 63.2675 10.4297 63.9282 11.0931C64.5888 11.7565 65.1119 12.5438 65.4674 13.4099C65.823 14.276 66.004 15.2038 66 16.14V58.89C66 60.7757 65.2509 62.5841 63.9175 63.9175C62.5841 65.2509 60.7757 66 58.89 66H13.14C12.2038 66.004 11.276 65.823 10.4099 65.4674C9.54382 65.1119 8.75647 64.5888 8.09307 63.9282C7.42966 63.2675 6.90326 62.4824 6.54407 61.6178C6.18489 60.7532 5.99999 59.8262 6 58.89V16.14C6 12.18 9.18 9 13.14 9Z"
            fill="white"
          ></path>
        </svg>
      );
    case LOTS_IDS.CFO:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36 6C30.4305 6 25.089 8.21249 21.1508 12.1508C17.2125 16.089 15 21.4305 15 27C15 34.14 18.57 40.41 24 44.22V51C24 51.7956 24.3161 52.5587 24.8787 53.1213C25.4413 53.6839 26.2044 54 27 54H45C45.7956 54 46.5587 53.6839 47.1213 53.1213C47.6839 52.5587 48 51.7956 48 51V44.22C53.43 40.41 57 34.14 57 27C57 21.4305 54.7875 16.089 50.8492 12.1508C46.911 8.21249 41.5695 6 36 6ZM27 63C27 63.7956 27.3161 64.5587 27.8787 65.1213C28.4413 65.6839 29.2044 66 30 66H42C42.7956 66 43.5587 65.6839 44.1213 65.1213C44.6839 64.5587 45 63.7956 45 63V60H27V63Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.COUVERTURE:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4011)">
            <path
              d="M2.99988 51.9216L35.9999 18.9216L68.9999 51.9216"
              stroke="white"
              strokeWidth="6.09"
            />
            <path
              d="M12.3749 41.4152L11.9999 72"
              stroke="white"
              strokeWidth="6.09"
            />
            <path d="M60 18V72" stroke="white" strokeWidth="6.09" />
            <path d="M51 18.9216V33.9216" stroke="white" strokeWidth="6.09" />
            <path d="M63 18.9216L48 18.9216" stroke="white" strokeWidth="6.09" />
            <path
              d="M11.9999 25.817C9.35405 25.817 7.02613 24.8953 5.01613 23.052C3.00529 21.2078 1.99988 18.7128 1.99988 15.567C1.99988 13.5878 2.74988 11.442 4.24988 9.12952C5.74988 6.81702 8.02071 4.31702 11.0624 1.62952C11.1874 1.52535 11.3332 1.44202 11.4999 1.37952C11.6665 1.31702 11.8332 1.28577 11.9999 1.28577C12.1665 1.28577 12.3332 1.31702 12.4999 1.37952C12.6665 1.44202 12.8124 1.52535 12.9374 1.62952C15.979 4.31702 18.2499 6.81702 19.7499 9.12952C21.2499 11.442 21.9999 13.5878 21.9999 15.567C21.9999 18.7128 20.9945 21.2078 18.9836 23.052C16.9736 24.8953 14.6457 25.817 11.9999 25.817ZM12.3436 22.067C12.5936 22.0462 12.8074 21.9474 12.9849 21.7708C13.1615 21.5933 13.2499 21.3795 13.2499 21.1295C13.2499 20.8378 13.1561 20.6037 12.9686 20.427C12.7811 20.2495 12.5415 20.1712 12.2499 20.192C11.3957 20.2545 10.4895 20.0203 9.53113 19.4895C8.57279 18.9578 7.96863 17.9941 7.71863 16.5983C7.67696 16.3691 7.56738 16.1816 7.38988 16.0358C7.21321 15.8899 7.01029 15.817 6.78113 15.817C6.48946 15.817 6.24988 15.9262 6.06238 16.1445C5.87488 16.3637 5.81238 16.6191 5.87488 16.9108C6.22904 18.8066 7.06238 20.1608 8.37488 20.9733C9.68738 21.7858 11.0103 22.1503 12.3436 22.067Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4011">
              <rect width="72" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.CVC:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.7999 66C29.2499 66 27.3129 65.237 25.9889 63.711C24.6649 62.185 24.0019 60.448 23.9999 58.5C23.9999 57.2 24.2879 55.937 24.8639 54.711C25.4399 53.485 26.3269 52.473 27.5249 51.675C28.6249 50.975 29.5129 50.075 30.1889 48.975C30.8649 47.875 31.3269 46.7 31.5749 45.45L30.6749 45C30.3749 44.85 30.0999 44.675 29.8499 44.475L22.9499 46.95C22.0999 47.25 21.2749 47.5 20.4749 47.7C19.6749 47.9 18.8499 48 17.9999 48C14.8499 48 12.0619 46.625 9.63588 43.875C7.20988 41.125 5.99788 37.1 5.99988 31.8C5.99988 29.25 6.76288 27.313 8.28888 25.989C9.81488 24.665 11.5259 24.002 13.4219 24C14.7219 24 15.9969 24.288 17.2469 24.864C18.4969 25.44 19.5219 26.327 20.3219 27.525C21.0219 28.625 21.9219 29.512 23.0219 30.186C24.1219 30.86 25.2969 31.323 26.5469 31.575L26.9969 30.675C27.1469 30.375 27.3219 30.1 27.5219 29.85L25.0469 22.95C24.7469 22.1 24.4969 21.275 24.2969 20.475C24.0969 19.675 23.9969 18.875 23.9969 18.075C23.9969 14.875 25.3719 12.062 28.1219 9.636C30.8719 7.21 34.8979 5.998 40.1999 6C42.7499 6 44.6879 6.763 46.0139 8.289C47.3399 9.815 48.0019 11.526 47.9999 13.422C47.9999 14.722 47.7119 15.997 47.1359 17.247C46.5599 18.497 45.6729 19.522 44.4749 20.322C43.3749 21.022 42.4879 21.922 41.8139 23.022C41.1399 24.122 40.6769 25.297 40.4249 26.547L41.3249 26.997C41.6249 27.147 41.8999 27.322 42.1499 27.522L49.0499 24.972C49.8999 24.672 50.7129 24.435 51.4889 24.261C52.2649 24.087 53.0769 24 53.9249 24C57.9749 24 60.9999 25.675 62.9999 29.025C64.9999 32.375 65.9999 36.1 65.9999 40.2C65.9999 42.75 65.1999 44.688 63.5999 46.014C61.9999 47.34 60.2249 48.002 58.2749 48C57.0249 48 55.8119 47.712 54.6359 47.136C53.4599 46.56 52.4729 45.673 51.6749 44.475C50.9749 43.375 50.0749 42.488 48.9749 41.814C47.8749 41.14 46.6999 40.677 45.4499 40.425L44.9999 41.325C44.8499 41.625 44.6749 41.9 44.4749 42.15L46.9499 49.05C47.2499 49.85 47.4999 50.613 47.6999 51.339C47.8999 52.065 47.9999 52.827 47.9999 53.625C48.0499 56.875 46.6999 59.75 43.9499 62.25C41.1999 64.75 37.1499 66 31.7999 66ZM35.9999 40.5C37.2499 40.5 38.3129 40.062 39.1889 39.186C40.0649 38.31 40.5019 37.248 40.4999 36C40.4999 34.75 40.0619 33.687 39.1859 32.811C38.3099 31.935 37.2479 31.498 35.9999 31.5C34.7499 31.5 33.6869 31.938 32.8109 32.814C31.9349 33.69 31.4979 34.752 31.4999 36C31.4999 37.25 31.9379 38.313 32.8139 39.189C33.6899 40.065 34.7519 40.502 35.9999 40.5Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.ECLAIRAGE_PUBLIC:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42 9L39 3H33L30 9L15 18H21L24 42L30 48L31.5 51H27V69H45V51H40.5L42 48L48 42L51 18H57L42 9ZM42.48 39H29.52L27 18H45L42.48 39Z"
            fill="#FAFBFF"
          />
        </svg>
      );
    case LOTS_IDS.ENERGIE:
      return (
        <svg
          width="50"
          height="72"
          viewBox="0 0 50 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.6304 0.304326C40.0708 0.559649 40.4116 0.956781 40.5972 1.43084C40.7827 1.90491 40.802 2.42788 40.6519 2.91433L32.5474 29.2483H47.5009C47.9403 29.2481 48.3702 29.3767 48.7375 29.618C49.1047 29.8593 49.3933 30.2029 49.5675 30.6064C49.7417 31.0098 49.7939 31.4555 49.7178 31.8883C49.6416 32.3211 49.4404 32.7221 49.1389 33.0418L13.1389 71.2918C12.7906 71.6622 12.327 71.9037 11.8239 71.977C11.3207 72.0502 10.8076 71.9508 10.3681 71.6951C9.92865 71.4394 9.58876 71.0423 9.40386 70.5686C9.21895 70.095 9.19993 69.5727 9.3499 69.0868L17.4544 42.7483H2.5009C2.06145 42.7485 1.63157 42.62 1.26432 42.3786C0.897079 42.1373 0.608544 41.7937 0.43434 41.3903C0.260137 40.9868 0.207889 40.5412 0.284048 40.1084C0.360206 39.6756 0.561436 39.2746 0.862897 38.9548L36.8629 0.704826C37.2108 0.334922 37.6736 0.0935844 38.1761 0.0200542C38.6785 -0.0534761 39.1911 0.0451251 39.6304 0.299826V0.304326Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.FACADES:
      return (
        <svg
          width="63"
          height="72"
          viewBox="0 0 63 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4021)">
            <path
              d="M61.3124 67.5H58.4999V3.375C58.4999 1.51102 56.9889 0 55.1249 0H7.87488C6.01089 0 4.49988 1.51102 4.49988 3.375V67.5H1.68738C0.755456 67.5 -0.00012207 68.2556 -0.00012207 69.1875V72H62.9999V69.1875C62.9999 68.2556 62.2443 67.5 61.3124 67.5ZM17.9999 10.6875C17.9999 9.75558 18.7555 9 19.6874 9H25.3124C26.2443 9 26.9999 9.75558 26.9999 10.6875V16.3125C26.9999 17.2444 26.2443 18 25.3124 18H19.6874C18.7555 18 17.9999 17.2444 17.9999 16.3125V10.6875ZM17.9999 24.1875C17.9999 23.2556 18.7555 22.5 19.6874 22.5H25.3124C26.2443 22.5 26.9999 23.2556 26.9999 24.1875V29.8125C26.9999 30.7444 26.2443 31.5 25.3124 31.5H19.6874C18.7555 31.5 17.9999 30.7444 17.9999 29.8125V24.1875ZM25.3124 45H19.6874C18.7555 45 17.9999 44.2444 17.9999 43.3125V37.6875C17.9999 36.7556 18.7555 36 19.6874 36H25.3124C26.2443 36 26.9999 36.7556 26.9999 37.6875V43.3125C26.9999 44.2444 26.2443 45 25.3124 45ZM35.9999 67.5H26.9999V55.6875C26.9999 54.7556 27.7555 54 28.6874 54H34.3124C35.2443 54 35.9999 54.7556 35.9999 55.6875V67.5ZM44.9999 43.3125C44.9999 44.2444 44.2443 45 43.3124 45H37.6874C36.7555 45 35.9999 44.2444 35.9999 43.3125V37.6875C35.9999 36.7556 36.7555 36 37.6874 36H43.3124C44.2443 36 44.9999 36.7556 44.9999 37.6875V43.3125ZM44.9999 29.8125C44.9999 30.7444 44.2443 31.5 43.3124 31.5H37.6874C36.7555 31.5 35.9999 30.7444 35.9999 29.8125V24.1875C35.9999 23.2556 36.7555 22.5 37.6874 22.5H43.3124C44.2443 22.5 44.9999 23.2556 44.9999 24.1875V29.8125ZM44.9999 16.3125C44.9999 17.2444 44.2443 18 43.3124 18H37.6874C36.7555 18 35.9999 17.2444 35.9999 16.3125V10.6875C35.9999 9.75558 36.7555 9 37.6874 9H43.3124C44.2443 9 44.9999 9.75558 44.9999 10.6875V16.3125Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4021">
              <rect width="63" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.FLUIDES:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 39V30C12 27.15 12.85 24.675 14.55 22.575C16.25 20.475 18.4 19.075 21 18.375V12C21 10.35 21.588 8.937 22.764 7.761C23.94 6.585 25.352 5.99801 27 6.00001H45C46.65 6.00001 48.063 6.58801 49.239 7.76401C50.415 8.94001 51.002 10.352 51 12V18.375C53.6 19.075 55.75 20.475 57.45 22.575C59.15 24.675 60 27.15 60 30V39H12ZM24 66C20.7 66 17.875 64.825 15.525 62.475C13.175 60.125 12 57.3 12 54V45H60V54C60 57.3 58.825 60.125 56.475 62.475C54.125 64.825 51.3 66 48 66H24ZM27 18H33C33 17.15 33.288 16.437 33.864 15.861C34.44 15.285 35.152 14.998 36 15C36.85 15 37.563 15.288 38.139 15.864C38.715 16.44 39.002 17.152 39 18H45V12H27V18Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.INFRASTRUCTURE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2.99988 12H68.9999" stroke="white" strokeWidth="9" />
          <path d="M25.5 16.5V46.5" stroke="white" strokeWidth="6" />
          <path
            d="M46.5 16.5V46.5H60V63H12V66V46.5H28.5"
            stroke="white"
            strokeWidth="6"
          />
          <path d="M36 13.5L24 25.5" stroke="white" strokeWidth="1.2" />
          <path d="M42 13.5L27 28.5" stroke="white" strokeWidth="1.2" />
          <path d="M51 46.4999L36 61.4999" stroke="white" strokeWidth="1.2" />
          <path d="M60 55.5L51 64.5" stroke="white" strokeWidth="1.2" />
          <path d="M60 49.5L45 64.5" stroke="white" strokeWidth="1.2" />
          <path d="M57 46.4999L42 61.4999" stroke="white" strokeWidth="1.2" />
          <path d="M45 46.4999L30 61.4999" stroke="white" strokeWidth="1.2" />
          <path d="M45 40.4999L24 61.4999" stroke="white" strokeWidth="1.2" />
          <path d="M45 34.5001L15 64.5001" stroke="white" strokeWidth="1.2" />
          <path d="M27 46.4999L12 61.4999" stroke="white" strokeWidth="1.2" />
          <path d="M24 43.5L12 55.5" stroke="white" strokeWidth="1.2" />
          <path d="M45 28.5001L27 46.5001" stroke="white" strokeWidth="1.2" />
          <path d="M48 19.5L27 40.5" stroke="white" strokeWidth="1.2" />
          <path d="M45 16.5L27 34.5" stroke="white" strokeWidth="1.2" />
        </svg>
      );
    case LOTS_IDS.IRVE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4082)">
            <g clipPath="url(#clip1_639_4082)">
              <path
                d="M20.4176 26.2176H26.2175V36.7828H13.8144L17.16 28.4296C17.6883 27.098 18.9759 26.2176 20.4176 26.2176ZM31.5001 36.7828V26.2176H40.4365C41.504 26.2176 42.5165 26.7018 43.1879 27.5382L50.5835 36.7828H31.5001ZM59.696 36.8928L48.6906 23.136C46.6876 20.6268 43.6501 19.1741 40.4365 19.1741H20.4176C16.0925 19.1741 12.2076 21.8044 10.6118 25.8103L6.03351 37.267C3.41422 38.3015 1.56531 40.8438 1.56531 43.8262V56.1523C1.56531 58.1003 3.13908 59.6741 5.08705 59.6741H8.75186C9.58827 64.6705 13.9354 68.4784 19.174 68.4784C24.4126 68.4784 28.7597 64.6705 29.5961 59.6741H43.9692C44.8057 64.6705 49.1528 68.4784 54.3914 68.4784C59.63 68.4784 63.9771 64.6705 64.8135 59.6741H68.4783C70.4263 59.6741 72.0001 58.1003 72.0001 56.1523V50.8697C72.0001 43.6942 66.6294 37.7733 59.696 36.8928ZM49.4059 56.1523C49.6301 55.4894 49.9838 54.8776 50.4465 54.3524C50.9091 53.8273 51.4715 53.3994 52.1009 53.0934C52.7303 52.7875 53.4143 52.6097 54.113 52.5703C54.8118 52.531 55.5114 52.6308 56.1712 52.8641C56.831 53.0974 57.4379 53.4595 57.9566 53.9294C58.4753 54.3992 58.8954 54.9674 59.1927 55.601C59.4899 56.2346 59.6583 56.921 59.688 57.6202C59.7177 58.3194 59.6082 59.0175 59.3658 59.6741C59.1417 60.337 58.788 60.9489 58.3253 61.474C57.8627 61.9991 57.3003 62.427 56.6709 62.733C56.0414 63.0389 55.3575 63.2167 54.6587 63.2561C53.96 63.2954 53.2604 63.1956 52.6006 62.9623C51.9408 62.729 51.3339 62.3669 50.8152 61.897C50.2965 61.4272 49.8763 60.859 49.5791 60.2254C49.2819 59.5918 49.1135 58.9055 49.0838 58.2062C49.054 57.507 49.1636 56.8089 49.4059 56.1523ZM19.174 52.6306C20.575 52.6306 21.9187 53.1872 22.9094 54.1778C23.9001 55.1685 24.4566 56.5122 24.4566 57.9132C24.4566 59.3142 23.9001 60.6579 22.9094 61.6486C21.9187 62.6393 20.575 63.1958 19.174 63.1958C17.773 63.1958 16.4293 62.6393 15.4386 61.6486C14.448 60.6579 13.8914 59.3142 13.8914 57.9132C13.8914 56.5122 14.448 55.1685 15.4386 54.1778C16.4293 53.1872 17.773 52.6306 19.174 52.6306Z"
                fill="white"
              />
              <path
                d="M0 1.56519H4.69565C6.42454 1.56519 7.82609 2.96673 7.82609 4.69562V15.6521C7.82609 16.9488 6.77493 18 5.47826 18V18M0 18H5.47826M5.47826 18V29.7698C5.47826 30.7523 5.08794 31.6946 4.39317 32.3894V32.3894C3.19111 33.5915 2.9614 35.4574 3.83604 36.9151L4.69565 38.3478"
                stroke="white"
                strokeWidth="3.13043"
              />
              <path d="M0 0V19.5654" stroke="white" strokeWidth="3.13043" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_639_4082">
              <rect width="20" height="20" fill="white" />
            </clipPath>
            <clipPath id="clip1_639_4082">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.MENUISERIE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.9999 57V15C59.9999 11.7 57.2999 9 53.9999 9H38.2499V57H33.7499V9H17.9999C14.6999 9 11.9999 11.7 11.9999 15V57C10.3499 57 8.99988 58.35 8.99988 60C8.99988 61.65 10.3499 63 11.9999 63H59.9999C61.6499 63 62.9999 61.65 62.9999 60C62.9999 58.35 61.6499 57 59.9999 57ZM26.9999 39C25.3499 39 23.9999 37.65 23.9999 36C23.9999 34.35 25.3499 33 26.9999 33C28.6499 33 29.9999 34.35 29.9999 36C29.9999 37.65 28.6499 39 26.9999 39ZM44.9999 39C43.3499 39 41.9999 37.65 41.9999 36C41.9999 34.35 43.3499 33 44.9999 33C46.6499 33 47.9999 34.35 47.9999 36C47.9999 37.65 46.6499 39 44.9999 39Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.OUVRAGE_ART:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.3086 8.03293C35.3663 8.67865 36.0009 9.82537 36.0009 11.0611V19.077H45.9094C46.3102 17.5406 47.7018 16.4051 49.3607 16.4051H59.1578C62.1081 16.4051 64.5018 18.7987 64.5018 21.749C64.5018 24.6993 62.1081 27.0929 59.1578 27.0929H49.3607C47.7018 27.0929 46.3102 25.9573 45.9094 24.4209H36.0009V32.4368C36.0009 33.6726 35.3663 34.8193 34.3086 35.465C33.251 36.1107 31.9484 36.1775 30.8462 35.6209L9.47057 24.9331C8.25705 24.3319 7.5 23.0961 7.5 21.749C7.5 20.4019 8.25705 19.1661 9.47057 18.5649L30.8462 7.87707C31.9484 7.32041 33.2621 7.38721 34.3086 8.03293ZM39.5635 35.9994C39.5635 34.0288 41.1555 32.4368 43.1261 32.4368H60.9391C62.9097 32.4368 64.5018 34.0288 64.5018 35.9994V43.1246C64.5018 45.0952 62.9097 46.6872 60.9391 46.6872H43.1261C41.1555 46.6872 39.5635 45.0952 39.5635 43.1246V35.9994ZM11.0626 50.2499H21.7504C23.721 50.2499 25.313 51.8419 25.313 53.8125V60.9377C25.313 62.9082 23.721 64.5003 21.7504 64.5003H11.0626C9.09204 64.5003 7.5 62.9082 7.5 60.9377V53.8125C7.5 51.8419 9.09204 50.2499 11.0626 50.2499ZM32.4383 50.2499H60.9391C62.9097 50.2499 64.5018 51.8419 64.5018 53.8125V60.9377C64.5018 62.9082 62.9097 64.5003 60.9391 64.5003H32.4383C30.4677 64.5003 28.8757 62.9082 28.8757 60.9377V53.8125C28.8757 51.8419 30.4677 50.2499 32.4383 50.2499Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.PLOMBERIE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57 28.5H39C30.7157 28.5 24 35.2157 24 43.5V43.5"
            stroke="white"
            strokeWidth="15"
          />
          <path d="M45 16.5V25.5" stroke="white" strokeWidth="9" />
          <path d="M45 16.5001V13.5001" stroke="white" strokeWidth="3" />
          <path
            d="M50.9999 8.90548C50.9999 12.167 48.3559 14.811 45.0944 14.811C41.8329 14.811 39.189 12.167 39.189 8.90548C39.189 5.64397 41.8329 3 45.0944 3C48.3559 3 50.9999 5.64397 50.9999 8.90548Z"
            fill="white"
          />
          <path
            d="M30 9H60"
            stroke="white"
            strokeWidth="4.5"
            strokeLinecap="round"
          />
          <path
            d="M63 18V39"
            stroke="white"
            strokeWidth="6"
            strokeLinecap="square"
          />
          <path
            d="M15 46.5H33"
            stroke="white"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <g clipPath="url(#clip0_639_4025)">
            <path
              d="M19.7143 62.7001C19.7143 63.8936 20.1658 65.0382 20.9695 65.8821C21.7733 66.726 22.8634 67.2001 24 67.2001C25.1366 67.2001 26.2267 66.726 27.0305 65.8821C27.8342 65.0382 28.2857 63.8936 28.2857 62.7001C28.2857 61.1467 26.8629 58.1722 24 54.0124C21.1371 58.1722 19.7143 61.1467 19.7143 62.7001ZM24 51.0001C28.0003 56.4811 30 60.3808 30 62.7001C30 64.371 29.3679 65.9734 28.2426 67.1549C27.1174 68.3364 25.5913 69.0001 24 69.0001C22.4087 69.0001 20.8826 68.3364 19.7574 67.1549C18.6321 65.9734 18 64.371 18 62.7001C18 60.3808 19.9997 56.4811 24 51.0001Z"
              fill="white"
            />
            <path
              d="M24.0001 71.0535C21.8835 71.0535 20.0211 70.3161 18.4131 68.8415C16.8045 67.3661 16.0001 65.3701 16.0001 62.8535C16.0001 61.2701 16.6001 59.5535 17.8001 57.7035C19.0001 55.8535 20.8168 53.8535 23.2501 51.7035C23.3501 51.6201 23.4668 51.5535 23.6001 51.5035C23.7335 51.4535 23.8668 51.4285 24.0001 51.4285C24.1335 51.4285 24.2668 51.4535 24.4001 51.5035C24.5335 51.5535 24.6501 51.6201 24.7501 51.7035C27.1835 53.8535 29.0001 55.8535 30.2001 57.7035C31.4001 59.5535 32.0001 61.2701 32.0001 62.8535C32.0001 65.3701 31.1958 67.3661 29.5871 68.8415C27.9791 70.3161 26.1168 71.0535 24.0001 71.0535ZM24.2751 68.0535C24.4751 68.0368 24.6461 67.9578 24.7881 67.8165C24.9295 67.6745 25.0001 67.5035 25.0001 67.3035C25.0001 67.0701 24.9251 66.8828 24.7751 66.7415C24.6251 66.5995 24.4335 66.5368 24.2001 66.5535C23.5168 66.6035 22.7918 66.4161 22.0251 65.9915C21.2585 65.5661 20.7751 64.7951 20.5751 63.6785C20.5418 63.4951 20.4541 63.3451 20.3121 63.2285C20.1708 63.1118 20.0085 63.0535 19.8251 63.0535C19.5918 63.0535 19.4001 63.1408 19.2501 63.3155C19.1001 63.4908 19.0501 63.6951 19.1001 63.9285C19.3835 65.4451 20.0501 66.5285 21.1001 67.1785C22.1501 67.8285 23.2085 68.1201 24.2751 68.0535V68.0535Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4025">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(12 48)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.RESEAUX:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48 27V33H24V27H30V24H12V30H6V6H12V12H36C37.5913 12 39.1174 12.6321 40.2426 13.7574C41.3679 14.8826 42 16.4087 42 18V27H48ZM30 45V54C30 55.5913 30.6321 57.1174 31.7574 58.2426C32.8826 59.3679 34.4087 60 36 60H60V66H66V42H60V48H42V45H48V39H24V45H30Z"
            fill="white"
          />
        </svg>
      );
    case 'sécurité incendie':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.3999 42.3001C14.3999 40.3669 14.6267 38.4661 15.0767 36.5905C15.5267 34.7185 16.2287 32.9257 17.1827 31.2193C17.3339 30.9565 17.4851 30.6829 17.6327 30.4021C17.7839 30.1213 17.9639 29.8621 18.1691 29.6173C18.3458 29.3803 18.5656 29.1787 18.8171 29.0233C19.0846 28.8784 19.3841 28.8025 19.6883 28.8025C19.9925 28.8025 20.292 28.8784 20.5595 29.0233C20.8306 29.163 21.0556 29.378 21.2075 29.6425L24.9479 35.7481C25.11 36.0207 25.3425 36.2445 25.6211 36.3961C25.9178 36.5498 26.2448 36.6359 26.5787 36.6481C26.8658 36.6608 27.1517 36.6032 27.4114 36.4802C27.6712 36.3572 27.8969 36.1726 28.0691 35.9425C28.316 35.6186 28.4871 35.2436 28.57 34.8449C28.6529 34.4461 28.6453 34.0339 28.5479 33.6385C28.4827 33.4064 28.3984 33.18 28.2959 32.9617C27.555 31.3862 26.9247 29.7611 26.4095 28.0981C25.9083 26.4089 25.662 24.6544 25.6787 22.8925C25.6787 20.5309 26.0747 18.4609 26.8595 16.6789C27.6479 14.8969 28.7423 13.3669 30.1499 12.0925C31.5539 10.8181 33.1955 9.78851 35.0711 9.00011C37.0078 8.1946 39.026 7.60075 41.0903 7.22891C41.348 7.18122 41.6132 7.19205 41.8662 7.26059C42.1191 7.32913 42.3535 7.45364 42.5519 7.62491C42.9839 7.99571 43.1999 8.45651 43.1999 9.00011C43.1999 11.8117 43.6787 14.4937 44.6327 17.0425C45.6003 19.6138 46.9367 22.0307 48.5999 24.2173L51.7211 28.2925C52.7723 29.6605 53.7371 31.0861 54.6191 32.5693C55.5011 34.0489 56.2139 35.5861 56.7575 37.1809C57.2975 38.7757 57.5819 40.4821 57.5999 42.3001C57.5999 44.3053 57.3551 46.2565 56.8691 48.1501C56.3919 50.0164 55.6731 51.8124 54.7307 53.4925C53.7947 55.1629 52.6859 56.6821 51.4115 58.0501C50.1291 59.4235 48.6733 60.624 47.0807 61.6213C45.4679 62.6329 43.7327 63.4141 41.8787 63.9577C39.9671 64.5074 37.9889 64.7909 35.9999 64.8001C34.0113 64.8101 32.0316 64.5349 30.1211 63.9829C28.2954 63.453 26.5538 62.6676 24.9479 61.6501C23.3562 60.6396 21.8924 59.4405 20.5883 58.0789C19.276 56.7102 18.1591 55.1668 17.2691 53.4925C16.366 51.7973 15.6582 50.005 15.1595 48.1501C14.6488 46.2423 14.3934 44.2751 14.3999 42.3001Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.SUPERSTRUCTURE:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_3979)">
            <path
              d="M62.9999 60.0001V6.00012H8.99988V60.0001H2.99988V69.0001H68.9999V60.0001H62.9999ZM56.9999 12.0001V33.0001H50.9999V12.0001H56.9999ZM14.9999 12.0001H20.9999V33.0001H14.9999V12.0001ZM14.9999 60.0001V39.0001H20.9999V60.0001H14.9999ZM26.9999 60.0001V12.0001H44.9999V60.0001H26.9999ZM50.9999 60.0001V39.0001H56.9999V60.0001H50.9999Z"
              fill="white"
            />
            <path d="M27 19.5H45" stroke="white" strokeWidth="4.5" />
            <path d="M24 9L12 21" stroke="white" strokeWidth="1.2" />
            <path d="M36 9L21 24" stroke="white" strokeWidth="1.2" />
            <path d="M24 21L12 33" stroke="white" strokeWidth="1.2" />
            <path d="M30 9L12 27" stroke="white" strokeWidth="1.2" />
            <path d="M42 9L30 21" stroke="white" strokeWidth="1.2" />
            <path d="M24 27L12 39" stroke="white" strokeWidth="1.2" />
            <path d="M24 36L12 48" stroke="white" strokeWidth="1.2" />
            <path d="M24 42L12 54" stroke="white" strokeWidth="1.2" />
            <path d="M24 48L12 60" stroke="white" strokeWidth="1.2" />
            <path d="M24 54L12 66" stroke="white" strokeWidth="1.2" />
            <path d="M48 9L36 21" stroke="white" strokeWidth="1.2" />
            <path d="M60 9L48 21" stroke="white" strokeWidth="1.2" />
            <path d="M60 15L48 27" stroke="white" strokeWidth="1.2" />
            <path d="M60 21L48 33" stroke="white" strokeWidth="1.2" />
            <path d="M60 27L48 39" stroke="white" strokeWidth="1.2" />
            <path d="M60 36L48 48" stroke="white" strokeWidth="1.2" />
            <path d="M60 42L48 54" stroke="white" strokeWidth="1.2" />
            <path d="M60 48L48 60" stroke="white" strokeWidth="1.2" />
            <path d="M60 54L48 66" stroke="white" strokeWidth="1.2" />
          </g>
          <defs>
            <clipPath id="clip0_639_3979">
              <rect width="72" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.SYSTEME_TRI_BAGAGES:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5002 60.0002C17.6936 60.0002 18.8382 60.4743 19.6822 61.3182C20.5261 62.1621 21.0002 63.3067 21.0002 64.5002C21.0002 65.6936 20.5261 66.8382 19.6822 67.6821C18.8382 68.5261 17.6936 69.0002 16.5002 69.0002C15.3067 69.0002 14.1621 68.5261 13.3182 67.6821C12.4743 66.8382 12.0002 65.6936 12.0002 64.5002C12.0002 63.3067 12.4743 62.1621 13.3182 61.3182C14.1621 60.4743 15.3067 60.0002 16.5002 60.0002ZM55.5002 60.0002C56.6936 60.0002 57.8382 60.4743 58.6821 61.3182C59.5261 62.1621 60.0002 63.3067 60.0002 64.5002C60.0002 65.6936 59.5261 66.8382 58.6821 67.6821C57.8382 68.5261 56.6936 69.0002 55.5002 69.0002C54.3067 69.0002 53.1621 68.5261 52.3182 67.6821C51.4743 66.8382 51.0002 65.6936 51.0002 64.5002C51.0002 63.3067 51.4743 62.1621 52.3182 61.3182C53.1621 60.4743 54.3067 60.0002 55.5002 60.0002ZM6.51617 5.27417L18.0002 16.7582V51.0002H60.0002V57.0002H15.0002C14.2045 57.0002 13.4415 56.6841 12.8789 56.1215C12.3162 55.5589 12.0002 54.7958 12.0002 54.0002V19.2422L2.27417 9.51617L6.51617 5.27417ZM48.0002 9.00017C48.7958 9.00017 49.5589 9.31624 50.1215 9.87885C50.6841 10.4415 51.0002 11.2045 51.0002 12.0002V18.0002H59.9822C61.6502 18.0002 63.0002 19.3682 63.0002 20.9882V45.0182C62.9978 45.4121 62.9179 45.8018 62.7649 46.1649C62.612 46.5279 62.389 46.8573 62.1088 47.1342C61.8285 47.4111 61.4965 47.6301 61.1316 47.7787C60.7667 47.9273 60.3761 48.0025 59.9822 48.0002H24.0212C23.2264 47.9994 22.4638 47.6859 21.8985 47.1272C21.3331 46.5686 21.0104 45.8099 21.0002 45.0152V20.9852C21.0021 20.5907 21.0819 20.2005 21.2348 19.8369C21.3878 19.4732 21.611 19.1434 21.8916 18.8661C22.1722 18.5888 22.5047 18.3696 22.8701 18.2211C23.2356 18.0725 23.6267 17.9974 24.0212 18.0002H33.0002V12.0002C33.0002 11.2045 33.3162 10.4415 33.8788 9.87885C34.4415 9.31624 35.2045 9.00017 36.0002 9.00017H48.0002ZM33.0002 24.0002H30.0002V42.0002H33.0002V24.0002ZM54.0002 24.0002H51.0002V42.0002H54.0002V24.0002ZM45.0002 15.0002H39.0002V18.0002H45.0002V15.0002Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.TERRE:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4051)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36 0C36.778 0.000400801 37.5389 0.227651 38.1897 0.653924C38.8405 1.0802 39.3528 1.68699 39.664 2.4L66.616 64H68C69.0609 64 70.0783 64.4214 70.8284 65.1716C71.5786 65.9217 72 66.9391 72 68C72 69.0609 71.5786 70.0783 70.8284 70.8284C70.0783 71.5786 69.0609 72 68 72H4C2.93913 72 1.92172 71.5786 1.17157 70.8284C0.421427 70.0783 0 69.0609 0 68C0 66.9391 0.421427 65.9217 1.17157 65.1716C1.92172 64.4214 2.93913 64 4 64H5.384L32.336 2.4C32.6472 1.68699 33.1595 1.0802 33.8103 0.653924C34.4611 0.227651 35.222 0.000400801 36 0ZM26.364 36H45.636L42.132 28H29.868L26.364 36ZM17.616 56H54.384L50.884 48H21.116L17.616 56Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4051">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.TRANSPORTS_ENGINS:
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57.45 24C56.9265 23.0932 56.1747 22.3391 55.2695 21.8128C54.3643 21.2866 53.3371 21.0063 52.29 21H45V15C45 14.2044 44.6839 13.4413 44.1213 12.8787C43.5587 12.3161 42.7956 12 42 12H12C10.4087 12 8.88258 12.6321 7.75736 13.7574C6.63214 14.8826 6 16.4087 6 18V48C6.00108 49.0522 6.27883 50.0856 6.80538 50.9965C7.33194 51.9075 8.08879 52.6639 9 53.19C8.89259 55.9748 9.89582 58.6882 11.789 60.7332C13.6822 62.7783 16.3102 63.9876 19.095 64.095C21.8798 64.2024 24.5932 63.1992 26.6382 61.306C28.6833 59.4128 29.8926 56.7848 30 54H39.3C39.6317 56.5101 40.8644 58.8141 42.7684 60.483C44.6724 62.152 47.1181 63.0721 49.65 63.0721C52.1819 63.0721 54.6276 62.152 56.5316 60.483C58.4356 58.8141 59.6683 56.5101 60 54C61.5913 54 63.1174 53.3679 64.2426 52.2426C65.3679 51.1174 66 49.5913 66 48V39C65.9953 38.4527 65.8507 37.9157 65.58 37.44L57.45 24ZM45 27H52.29L57.69 36H45V27ZM19.5 57C18.61 57 17.74 56.7361 16.9999 56.2416C16.2599 55.7471 15.6831 55.0443 15.3425 54.2221C15.0019 53.3998 14.9128 52.495 15.0865 51.6221C15.2601 50.7492 15.6887 49.9474 16.318 49.318C16.9474 48.6887 17.7492 48.2601 18.6221 48.0865C19.495 47.9128 20.3998 48.002 21.2221 48.3425C22.0443 48.6831 22.7471 49.2599 23.2416 49.9999C23.7361 50.74 24 51.61 24 52.5C24 53.6935 23.5259 54.8381 22.682 55.682C21.8381 56.5259 20.6935 57 19.5 57ZM49.5 57C48.61 57 47.74 56.7361 46.9999 56.2416C46.2599 55.7471 45.6831 55.0443 45.3425 54.2221C45.0019 53.3998 44.9128 52.495 45.0865 51.6221C45.2601 50.7492 45.6887 49.9474 46.318 49.318C46.9474 48.6887 47.7492 48.2601 48.6221 48.0865C49.495 47.9128 50.3998 48.002 51.2221 48.3425C52.0443 48.6831 52.7471 49.2599 53.2416 49.9999C53.7361 50.74 54 51.61 54 52.5C54 53.6935 53.5259 54.8381 52.682 55.682C51.8381 56.5259 50.6935 57 49.5 57Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.VRD:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4045)">
            <path
              d="M19.529 6H31.5V20.8235H38.9118V6H50.9624C52.6064 6 54.0538 7.08305 54.5177 8.66021L70.8672 64.2484C71.5653 66.622 69.786 69 67.3119 69H38.9118V50.4706H31.5V69H4.81449C2.38242 69 0.609643 66.6969 1.23199 64.3458L15.9465 8.75757C16.3768 7.13208 17.8475 6 19.529 6Z"
              fill="white"
            />
            <path d="M31.5 43.0589V28.2354H38.9118V43.0589H31.5Z" fill="#CE4C33" />
          </g>
          <defs>
            <clipPath id="clip0_639_4045">
              <rect
                width="72"
                height="72"
                fill="white"
                transform="translate(0 -0.000244141)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "poste d'inspection filtrage":
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4063)">
            <path
              d="M32.3156 0.295311C31.9922 0.464066 31.6687 0.787498 31.5 1.125C31.2188 1.67344 31.2188 1.88438 31.2188 36C31.2188 70.1297 31.2188 70.3266 31.5 70.875C31.8234 71.5078 32.625 72 33.3281 72C34.0312 72 34.8328 71.5078 35.1562 70.875C35.4375 70.3266 35.4375 70.1016 35.4375 45.7031V21.0938H51.6094H67.7812V45.7031C67.7812 70.1016 67.7812 70.3266 68.0625 70.875C68.3859 71.5078 69.1875 72 69.8906 72C70.5938 72 71.3953 71.5078 71.7188 70.875C72 70.3266 72 70.1297 72 36C72 1.87032 72 1.67344 71.7188 1.125C71.5359 0.759377 71.2406 0.464066 70.875 0.28125C70.3266 0 70.0875 0 51.5812 0C33.2016 0.014061 32.8219 0.014061 32.3156 0.295311ZM44.1562 8.71875C44.7891 9.04219 45.2812 9.84375 45.2812 10.5469C45.2812 11.6156 44.2406 12.6562 43.1578 12.6562C42.5109 12.6562 41.6391 12.1078 41.3297 11.5031C40.8094 10.4906 41.1328 9.37969 42.1312 8.775C42.8062 8.36719 43.425 8.35313 44.1562 8.71875ZM52.5938 8.71875C53.2266 9.04219 53.7188 9.84375 53.7188 10.5469C53.7188 11.6156 52.6781 12.6562 51.5953 12.6562C50.9484 12.6562 50.0766 12.1078 49.7672 11.5031C49.2469 10.4906 49.5703 9.37969 50.5688 8.775C51.2437 8.36719 51.8625 8.35313 52.5938 8.71875ZM61.0312 8.71875C61.6641 9.04219 62.1562 9.84375 62.1562 10.5469C62.1562 11.6156 61.1156 12.6562 60.0328 12.6562C59.3859 12.6562 58.5141 12.1078 58.2047 11.5031C57.6844 10.4906 58.0078 9.37969 59.0062 8.775C59.6812 8.36719 60.3 8.35313 61.0312 8.71875Z"
              fill="white"
            />
            <path
              d="M6.72187 21.6703C6.39844 21.8391 6.075 22.1625 5.90625 22.5C5.63906 23.0203 5.625 23.3156 5.625 29.1094C5.625 34.9031 5.63906 35.1984 5.90625 35.7188C6.08906 36.0844 6.38437 36.3797 6.75 36.5625C7.25625 36.8156 7.56562 36.8438 10.7578 36.8438H14.2031V38.9531V41.0625H7.94531C1.94062 41.0625 1.65937 41.0766 1.125 41.3438C0.759375 41.5266 0.464062 41.8219 0.28125 42.1875C0 42.7219 0 42.9891 0 56.5312C0 70.0734 0 70.3406 0.28125 70.875C0.604687 71.5078 1.40625 72 2.10937 72C2.8125 72 3.61406 71.5078 3.9375 70.875C4.20469 70.3406 4.21875 70.0594 4.21875 62.0156V53.7188H15.6094H27V47.3906V41.0625H22.7109H18.4219V38.9531V36.8438H21.8672C25.0594 36.8438 25.3687 36.8156 25.875 36.5625C26.2406 36.3797 26.5359 36.0844 26.7187 35.7188C26.9859 35.1984 27 34.9031 27 29.1094C27 23.3156 26.9859 23.0203 26.7187 22.5C26.5359 22.1344 26.2406 21.8391 25.875 21.6562C25.3406 21.3891 25.0734 21.375 16.2844 21.375C7.56562 21.3891 7.22812 21.4031 6.72187 21.6703Z"
              fill="white"
            />
            <path
              d="M50.1326 25.7904C48.9655 26.0716 48.0795 26.5779 47.1655 27.4779C45.253 29.4045 44.7608 32.217 45.942 34.706C46.4342 35.7607 47.7842 37.0967 48.8389 37.5888C51.342 38.756 54.1264 38.292 56.0389 36.3654C58.542 33.8482 58.542 29.981 56.053 27.4779C54.4498 25.8748 52.2983 25.256 50.1326 25.7904Z"
              fill="white"
            />
            <path
              d="M44.2828 40.5281C44.0437 40.8656 43.6219 41.5828 43.3687 42.1172C42.5391 43.8469 42.4688 44.4375 42.4688 50.6672C42.4688 55.9969 42.4828 56.2922 42.75 56.8125C42.9328 57.1781 43.2281 57.4734 43.5938 57.6562C44.1281 57.9234 44.4094 57.9375 51.6094 57.9375C58.8094 57.9375 59.0906 57.9234 59.625 57.6562C59.9906 57.4734 60.2859 57.1781 60.4688 56.8125C60.7359 56.2922 60.75 55.9969 60.75 50.6672C60.75 44.4375 60.6797 43.8469 59.85 42.1172C59.5969 41.5828 59.175 40.8656 58.9359 40.5281L58.4859 39.9234L57.825 40.4016C56.9109 41.0766 55.6734 41.6812 54.4219 42.075C53.55 42.3422 53.0578 42.3984 51.6094 42.3984C50.1609 42.3984 49.6687 42.3422 48.7969 42.075C47.5453 41.6812 46.3078 41.0766 45.3937 40.4016L44.7328 39.9234L44.2828 40.5281Z"
              fill="white"
            />
            <path
              d="M45.2812 63.2143C45.2812 69.0429 45.2953 69.4929 45.5625 70.2857C45.7453 70.8429 46.0406 71.2929 46.4062 71.5714C46.9266 71.9786 47.2219 72 51.6094 72C55.9969 72 56.2922 71.9786 56.8125 71.5714C57.1781 71.2929 57.4734 70.8429 57.6562 70.2857C57.9234 69.4929 57.9375 69.0429 57.9375 63.2143V57H51.6094H45.2812V63.2143Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4063">
              <rect width="72" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'produits sur mesure':
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M59.363 34.481C55.9001 34.481 53.0854 35.6751 51.0213 37.5345L42.8843 29.2952C41.2638 31.0181 39.5238 32.3146 36.965 32.3146C33.2121 32.3146 31.0797 29.7558 31.0797 26.3611C31.0797 22.9664 33.2121 20.4076 36.6579 20.4076C38.9438 20.4076 40.4108 21.4994 41.5026 22.5399L45.0508 18.6506C43.0208 16.5523 40.2402 15 36.675 15C29.4592 15 24.9045 20.0835 24.9045 26.3611C24.9045 28.6469 25.5016 30.711 26.5933 32.5022L21.6122 37.5857C19.5481 35.6922 16.7334 34.5322 13.2705 34.5322C6.05467 34.5322 1.5 39.6157 1.5 45.8933C1.5 52.1709 6.08878 57.2885 13.2705 57.2885C20.4522 57.2885 25.041 52.1709 25.041 45.8933C25.041 44.1703 24.6998 42.5327 24.0516 41.0486L29.4762 35.5728C31.4038 36.9375 33.8262 37.7392 36.692 37.7392C39.5579 37.7392 41.5708 36.9033 43.3108 35.7092L48.599 41.0315C47.9678 42.4986 47.6096 44.1533 47.6096 45.8762C47.6096 52.1538 52.1984 57.2714 59.3801 57.2714C66.5618 57.2714 71.1506 52.1538 71.1506 45.8762C71.1506 39.5986 66.5788 34.481 59.363 34.481ZM13.2364 51.8638C9.68816 51.8638 7.65818 49.2368 7.65818 45.8421C7.65818 42.4474 9.68816 39.8886 13.2364 39.8886C16.7846 39.8886 18.8145 42.4474 18.8145 45.8421C18.8145 49.2368 16.7675 51.8638 13.2364 51.8638ZM59.363 51.8638C55.8148 51.8638 53.7848 49.2368 53.7848 45.8421C53.7848 42.4474 55.8148 39.8886 59.363 39.8886C62.9112 39.8886 64.9412 42.4474 64.9412 45.8421C64.9412 49.2368 62.8942 51.8638 59.363 51.8638Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.PRODUITS_MODELISES:
        return (
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M59.363 34.481C55.9001 34.481 53.0854 35.6751 51.0213 37.5345L42.8843 29.2952C41.2638 31.0181 39.5238 32.3146 36.965 32.3146C33.2121 32.3146 31.0797 29.7558 31.0797 26.3611C31.0797 22.9664 33.2121 20.4076 36.6579 20.4076C38.9438 20.4076 40.4108 21.4994 41.5026 22.5399L45.0508 18.6506C43.0208 16.5523 40.2402 15 36.675 15C29.4592 15 24.9045 20.0835 24.9045 26.3611C24.9045 28.6469 25.5016 30.711 26.5933 32.5022L21.6122 37.5857C19.5481 35.6922 16.7334 34.5322 13.2705 34.5322C6.05467 34.5322 1.5 39.6157 1.5 45.8933C1.5 52.1709 6.08878 57.2885 13.2705 57.2885C20.4522 57.2885 25.041 52.1709 25.041 45.8933C25.041 44.1703 24.6998 42.5327 24.0516 41.0486L29.4762 35.5728C31.4038 36.9375 33.8262 37.7392 36.692 37.7392C39.5579 37.7392 41.5708 36.9033 43.3108 35.7092L48.599 41.0315C47.9678 42.4986 47.6096 44.1533 47.6096 45.8762C47.6096 52.1538 52.1984 57.2714 59.3801 57.2714C66.5618 57.2714 71.1506 52.1538 71.1506 45.8762C71.1506 39.5986 66.5788 34.481 59.363 34.481ZM13.2364 51.8638C9.68816 51.8638 7.65818 49.2368 7.65818 45.8421C7.65818 42.4474 9.68816 39.8886 13.2364 39.8886C16.7846 39.8886 18.8145 42.4474 18.8145 45.8421C18.8145 49.2368 16.7675 51.8638 13.2364 51.8638ZM59.363 51.8638C55.8148 51.8638 53.7848 49.2368 53.7848 45.8421C53.7848 42.4474 55.8148 39.8886 59.363 39.8886C62.9112 39.8886 64.9412 42.4474 64.9412 45.8421C64.9412 49.2368 62.8942 51.8638 59.363 51.8638Z"
              fill="white"
            />
          </svg>
        );
    case LOTS_IDS.CLOISON_PLAFOND:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.2375 0.0796871C1.25156 0.126562 1.56562 1.06875 1.93594 2.17969L2.61094 4.19531L4.425 4.20937L6.23437 4.21875L6.21094 4.11562C6.1875 3.99844 5.53125 0.0703125 5.53125 0.0234375C5.53125 0.00937462 4.56094 0 3.37031 0C1.33594 0 1.21406 0.00468731 1.2375 0.0796871Z"
            fill="white"
          />
          <path
            d="M7.30313 2.10938L7.65469 4.21875H9.47813H11.2969V2.10938V0H9.12657H6.95157L7.30313 2.10938Z"
            fill="white"
          />
          <path
            d="M12.7031 2.10938V4.21875H14.5219H16.3453L16.6969 2.10938L17.0484 0H14.8734H12.7031V2.10938Z"
            fill="white"
          />
          <path
            d="M18.4688 0.0234375C18.4688 0.0703125 17.8125 3.99844 17.7891 4.11562L17.7656 4.21875L19.575 4.20937L21.3891 4.19531L22.0641 2.17969C22.4344 1.06875 22.7484 0.126562 22.7625 0.0796871C22.7859 0.00468731 22.6641 0 20.6297 0C19.4391 0 18.4688 0.00937462 18.4688 0.0234375Z"
            fill="white"
          />
          <path
            d="M0.0046875 11.9297L0 22.9922L2.10938 20.8828L4.21875 18.7734V16.125V13.4766L2.11406 7.17187L0.009375 0.867188L0.0046875 11.9297Z"
            fill="white"
          />
          <path
            d="M21.8766 7.18594L19.7812 13.4766V16.125V18.7734L21.8906 20.8828L24 22.9922V11.9391C24 5.86406 23.9953 0.890625 23.9859 0.890625C23.9813 0.890625 23.0344 3.72187 21.8766 7.18594Z"
            fill="white"
          />
          <path
            d="M3.13123 5.65312C3.11717 5.66719 3.31404 6.30937 3.57186 7.08281L4.04061 8.48438H5.48905C6.28592 8.48438 6.93748 8.47969 6.93748 8.47031C6.92811 8.33906 6.46873 5.70937 6.4453 5.67188C6.41248 5.62031 3.17811 5.60156 3.13123 5.65312Z"
            fill="white"
          />
          <path
            d="M7.92656 5.75156C7.92656 5.82656 8.025 6.46406 8.14687 7.17188L8.36719 8.46094L9.83437 8.475L11.2969 8.48438V7.05469V5.625H9.60937H7.92188L7.92656 5.75156Z"
            fill="white"
          />
          <path
            d="M12.7031 7.05469V8.48438L14.1703 8.475L15.6328 8.46094L15.8531 7.17188C15.975 6.46406 16.0734 5.82656 16.0734 5.75156L16.0781 5.625H14.3906H12.7031V7.05469Z"
            fill="white"
          />
          <path
            d="M17.5547 5.67188C17.5313 5.70937 17.0719 8.33906 17.0625 8.47031C17.0625 8.47969 17.7141 8.48438 18.5109 8.48438H19.9594L20.4281 7.08281C20.6859 6.30937 20.8828 5.66719 20.8688 5.65312C20.8219 5.60156 17.5875 5.62031 17.5547 5.67188Z"
            fill="white"
          />
          <path
            d="M4.97812 11.2969L5.44687 12.7031H6.54843H7.64999L7.62187 12.5719C7.60781 12.5016 7.50937 11.9297 7.40624 11.2969C7.30312 10.6641 7.20468 10.0922 7.19062 10.0172L7.16249 9.89062H5.83593H4.50937L4.97812 11.2969Z"
            fill="white"
          />
          <path
            d="M8.625 9.94687C8.625 9.97969 8.72344 10.6125 8.84531 11.3531L9.07031 12.7031H10.1813H11.2969V11.2969V9.89062H9.96094C8.925 9.89062 8.625 9.90469 8.625 9.94687Z"
            fill="white"
          />
          <path
            d="M12.7031 11.2969V12.7031H13.8188H14.9297L15.1547 11.3531C15.2766 10.6125 15.375 9.97969 15.375 9.94687C15.375 9.90469 15.075 9.89062 14.0391 9.89062H12.7031V11.2969Z"
            fill="white"
          />
          <path
            d="M16.8094 10.0172C16.7953 10.0922 16.6969 10.6641 16.5937 11.2969C16.4906 11.9297 16.3922 12.5016 16.3781 12.5719L16.35 12.7031H17.4515H18.5531L19.0219 11.2969L19.4906 9.89062H18.164H16.8375L16.8094 10.0172Z"
            fill="white"
          />
          <path
            d="M5.64845 14.1656C5.63439 14.1984 5.6297 15.1547 5.63439 16.2891L5.64845 18.3516H12H18.3516V16.2422V14.1328L12.0094 14.1187C6.96095 14.1094 5.66251 14.1187 5.64845 14.1656Z"
            fill="white"
          />
          <path
            d="M3.11719 21.8906L1.00781 24H12H22.9922L20.8828 21.8906L18.7734 19.7812H12H5.22656L3.11719 21.8906Z"
            fill="white"
          />
        </svg>
      );
    case LOTS_IDS.REVETEMENTS_PEINTURES:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4041)">
            <path
              d="M8.99988 15C8.99988 12.6131 9.94809 10.3239 11.6359 8.63604C13.3237 6.94821 15.6129 6 17.9999 6H47.9999C50.3868 6 52.676 6.94821 54.3638 8.63604C56.0517 10.3239 56.9999 12.6131 56.9999 15H59.9999C61.5912 15 63.1173 15.6321 64.2425 16.7574C65.3677 17.8826 65.9999 19.4087 65.9999 21V25.14C65.9997 28.86 64.6172 32.4472 62.1209 35.2052C59.6246 37.9632 56.1924 39.6952 52.4909 40.065L35.9999 41.715V42C37.5912 42 39.1173 42.6321 40.2425 43.7574C41.3677 44.8826 41.9999 46.4087 41.9999 48V60C41.9999 61.5913 41.3677 63.1174 40.2425 64.2426C39.1173 65.3679 37.5912 66 35.9999 66H29.9999C28.4086 66 26.8825 65.3679 25.7572 64.2426C24.632 63.1174 23.9999 61.5913 23.9999 60V48C23.9999 46.4087 24.632 44.8826 25.7572 43.7574C26.8825 42.6321 28.4086 42 29.9999 42V41.715C29.9999 40.2271 30.5528 38.7923 31.5512 37.6891C32.5497 36.5859 33.9224 35.893 35.4029 35.745L51.8969 34.095C54.1174 33.8726 56.1761 32.8331 57.6734 31.1784C59.1707 29.5236 59.9998 27.3716 59.9999 25.14V21H56.9999C56.9999 23.3869 56.0517 25.6761 54.3638 27.364C52.676 29.0518 50.3868 30 47.9999 30H17.9999C15.6129 30 13.3237 29.0518 11.6359 27.364C9.94809 25.6761 8.99988 23.3869 8.99988 21V15Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4041">
              <rect width="72" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.DEPLACEMENT_INT:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_639_4055)">
            <path
              d="M18.6609 0.660937L9.66094 9.66094C9.01406 10.3078 8.83125 11.2781 9.16875 12.1078C9.50625 12.9375 10.3359 13.5 11.25 13.5H29.25C30.1641 13.5 30.9797 12.9516 31.3313 12.1078C31.6828 11.2641 31.4859 10.2937 30.8391 9.66094L21.8391 0.660937C20.9672 -0.210938 19.5328 -0.210938 18.6609 0.660937ZM9 18C4.03594 18 0 22.0359 0 27V63C0 67.9641 4.03594 72 9 72H63C67.9641 72 72 67.9641 72 63V27C72 22.0359 67.9641 18 63 18H9ZM22.5 31.5C24.2902 31.5 26.0071 32.2112 27.273 33.477C28.5388 34.7429 29.25 36.4598 29.25 38.25C29.25 40.0402 28.5388 41.7571 27.273 43.023C26.0071 44.2888 24.2902 45 22.5 45C20.7098 45 18.9929 44.2888 17.727 43.023C16.4612 41.7571 15.75 40.0402 15.75 38.25C15.75 36.4598 16.4612 34.7429 17.727 33.477C18.9929 32.2112 20.7098 31.5 22.5 31.5ZM11.25 56.25C11.25 52.5234 14.2734 49.5 18 49.5H27C30.7266 49.5 33.75 52.5234 33.75 56.25V58.5C33.75 60.9891 31.7391 63 29.25 63H15.75C13.2609 63 11.25 60.9891 11.25 58.5V56.25ZM38.25 56.25C38.25 52.5234 41.2734 49.5 45 49.5H54C57.7266 49.5 60.75 52.5234 60.75 56.25V58.5C60.75 60.9891 58.7391 63 56.25 63H42.75C40.2609 63 38.25 60.9891 38.25 58.5V56.25ZM42.75 38.25C42.75 37.3636 42.9246 36.4858 43.2638 35.6669C43.603 34.8479 44.1002 34.1038 44.727 33.477C45.3538 32.8502 46.0979 32.353 46.9169 32.0138C47.7358 31.6746 48.6136 31.5 49.5 31.5C50.3864 31.5 51.2642 31.6746 52.0831 32.0138C52.9021 32.353 53.6462 32.8502 54.273 33.477C54.8998 34.1038 55.397 34.8479 55.7362 35.6669C56.0754 36.4858 56.25 37.3636 56.25 38.25C56.25 39.1364 56.0754 40.0142 55.7362 40.8331C55.397 41.6521 54.8998 42.3962 54.273 43.023C53.6462 43.6498 52.9021 44.147 52.0831 44.4862C51.2642 44.8254 50.3864 45 49.5 45C48.6136 45 47.7358 44.8254 46.9169 44.4862C46.0979 44.147 45.3538 43.6498 44.727 43.023C44.1002 42.3962 43.603 41.6521 43.2638 40.8331C42.9246 40.0142 42.75 39.1364 42.75 38.25ZM50.1609 12.8391C51.0328 13.7109 52.4672 13.7109 53.3391 12.8391L62.3391 3.83906C62.9859 3.19219 63.1687 2.22187 62.8312 1.39219C62.4937 0.5625 61.6641 0 60.75 0H42.75C41.8359 0 41.0203 0.548437 40.6688 1.39219C40.3172 2.23594 40.5141 3.20625 41.1609 3.83906L50.1609 12.8391Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4055">
              <rect width="72" height="72" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.ENERGIE_SIMPLIFIEE:
      return (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.1951 54.0001C39.3312 54.0363 42.443 53.4452 45.3475 52.2617C48.252 51.0782 50.8906 49.3261 53.1084 47.1084C55.3261 44.8906 57.0782 42.252 58.2617 39.3475C59.4452 36.443 60.0363 33.3312 60.0001 30.1951C59.8921 16.9381 49.0621 6.10507 35.8051 6.00007C32.669 5.96429 29.5574 6.55559 26.6531 7.73923C23.7488 8.92287 21.1103 10.675 18.8927 12.8927C16.675 15.1103 14.9229 17.7488 13.7392 20.6531C12.5556 23.5574 11.9643 26.669 12.0001 29.8051C12.1081 43.0621 22.9381 53.8951 36.1951 54.0001Z"
            fill="white"
          />
          <path
            d="M33.3506 62.7718C33.4797 62.8239 33.6133 62.8641 33.7496 62.8918V65.9998C33.7496 66.5966 33.9867 67.1689 34.4086 67.5908C34.8306 68.0128 35.4029 68.2498 35.9996 68.2498C36.5964 68.2498 37.1687 68.0128 37.5906 67.5908C38.0126 67.1689 38.2496 66.5966 38.2496 65.9998V62.8948C38.386 62.8671 38.5196 62.8269 38.6486 62.7748C39.3828 62.469 39.9655 61.8841 40.2686 61.1488C40.4996 60.5968 40.4996 59.8978 40.4996 58.4998V56.6878C37.5134 57.1473 34.4714 57.1037 31.4996 56.5588V58.4998C31.4996 59.8978 31.4996 60.5998 31.7276 61.1488C32.0321 61.8836 32.6159 62.4674 33.3506 62.7718Z"
            fill="white"
          />
          <g clipPath="url(#clip0_639_4076)">
            <path
              d="M29.6256 17.1768C29.6745 17.2052 29.7124 17.2493 29.733 17.302C29.7536 17.3546 29.7558 17.4127 29.7391 17.4668L28.8386 20.3928H30.5001C30.5489 20.3928 30.5967 20.4071 30.6375 20.4339C30.6783 20.4607 30.7104 20.4989 30.7297 20.5437C30.7491 20.5885 30.7549 20.638 30.7464 20.6861C30.738 20.7342 30.7156 20.7788 30.6821 20.8143L26.6821 25.0643C26.6434 25.1055 26.5919 25.1323 26.536 25.1404C26.4801 25.1486 26.4231 25.1375 26.3742 25.1091C26.3254 25.0807 26.2876 25.0366 26.2671 24.9839C26.2466 24.9313 26.2444 24.8733 26.2611 24.8193L27.1616 21.8928H25.5001C25.4513 21.8928 25.4035 21.8785 25.3627 21.8517C25.3219 21.8249 25.2898 21.7867 25.2705 21.7419C25.2511 21.6971 25.2453 21.6476 25.2538 21.5995C25.2622 21.5514 25.2846 21.5068 25.3181 21.4713L29.3181 17.2213C29.3568 17.1802 29.4082 17.1534 29.464 17.1452C29.5198 17.137 29.5768 17.148 29.6256 17.1763V17.1768Z"
              fill="#FFD2B7"
            />
          </g>
          <defs>
            <clipPath id="clip0_639_4076">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(24 17.1431)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case LOTS_IDS.EAU:
      return (
        <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M37.5 62.5C32.5272 62.5 27.7581 60.5246 24.2417 57.0083C20.7254 53.4919 18.75 48.7228 18.75 43.75C18.75 31.25 37.5 10.1562 37.5 10.1562C37.5 10.1562 56.25 31.25 56.25 43.75C56.25 48.7228 54.2746 53.4919 50.7583 57.0083C47.2419 60.5246 42.4728 62.5 37.5 62.5Z" fill="white"/>
</svg>
      );
          default:
      return '';
  }
};

export const returnIconButton = (currentNode, tooltipForCalculatorSource) => {
  const tooltipTitle =
    tooltipForCalculatorSource && tooltipForCalculatorSource.length > 0
      ? tooltipForCalculatorSource
      : currentNode.name;

  if (currentNode)
    return (
      <Tooltip title={tooltipTitle} placement="top">
        <div className="lot-icon" style={{ background: currentNode.color }}>
          {currentNode.AllotmentId === 1 ? (
            returnLotIcon(currentNode.id)
          ) : (
            <span style={{ color: 'white', fontWeight: '500' }}>
              {currentNode.name?.slice(0, 4)}
            </span>
          )}
        </div>
      </Tooltip>
    );
};

export const returnBadgeTypeFiche = (type_fiche, screen) => {
  if (type_fiche === 'EMPTY') return;
  if (type_fiche === 'users') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#63A1FF',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        Nooco
      </p>
    );
  } else if (type_fiche === 'bundle') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#465292',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        Ensembles
      </p>
    );
  } else if (type_fiche === 'custom_user') {
    return (
      <div>
        <img src={customEquipmentIcon} alt="" />
      </div>
    );
  } else if (type_fiche?.includes('REFURBISHED')) {
    return (
      <Tooltip title="Composant réemploi">
        <img
          src={refurbishedIcon}
          alt=""
          style={{ width: '27px', marginRight: '10px' }}
        />
      </Tooltip>
    );
  } else if (type_fiche === 'FC') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#e8a838',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        Config
      </p>
    );
  } else if (type_fiche === 'DEC' || type_fiche === 'FORFAIT') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#8e67ff',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        {type_fiche}
      </p>
    );
  } else if (type_fiche === 'DED') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#363e63',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        DED
      </p>
    );
  } else if (type_fiche === 'FE') {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#0061CC',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        FE
      </p>
    );
  } else if (type_fiche?.includes('Collectif')) {
    const typeFicheFormat = type_fiche.split(' ');

    return (
      <>
        <Tooltip title={type_fiche}>
          <span
            className="badge"
            style={{
              backgroundColor: '#1C9782',
              color: 'white',
              margin: 0,
              opacity: 1,
            }}
          >
            {typeFicheFormat[0]}
          </span>
        </Tooltip>

        {screen === 'filter' && (
          <span style={{ fontSize: '9px', color: '#A3AED0' }}>Collectif</span>
        )}
      </>
    );
  } else {
    return (
      <p
        className="badge"
        style={{
          backgroundColor: '#43ddc4',
          color: 'white',
          margin: 0,
          opacity: 1,
        }}
      >
        {type_fiche !== 'users' && type_fiche !== 'FC' ? type_fiche : null}
      </p>
    );
  }
};

export const returnSearchBarOptionsFiltered = ({
  allAllotments,
  allotmentsAvailable,
  iniesOptions = [],
  bundleOptions = [],
  modeledProductOptions = [],
  configuredSheetOptions = [],
}) => {
  const energie = allotmentsAvailable.filter((node) =>
    findParentNode(node, allAllotments, [], [])[0]
      .id === LOTS_IDS.ENERGIE
      
  );

  const eau = allotmentsAvailable.filter(
    (node) =>
      findParentNode(node, allAllotments, [], [])[0].id === LOTS_IDS.EAU
  );

  const déchets = allotmentsAvailable.filter(
    (node) =>
      findParentNode(node, allAllotments, [], [])[0].id === LOTS_IDS.DECHETS
  );

  const inies = iniesOptions;

  const ensembles = bundleOptions;

  const lotsIdsToRemoveInEquipments = [LOTS_IDS.ENERGIE, LOTS_IDS.EAU];
  const equipements = allotmentsAvailable.filter(
    (node) => !lotsIdsToRemoveInEquipments.includes(findParentNode(node, allAllotments, [], [])[0].id)
  );

  const searchBarOptions = {
    energie: formatSearchBarOptions(energie),
    eau: formatSearchBarOptions(eau),
    inies: formatSearchBarOptions(inies),
    ensembles: formatSearchBarOptions(ensembles, true),
    equipements: formatSearchBarOptions(equipements),
    [SEARCH_GROUP_OPTION_VALUES.PRODUITS]: formatSearchBarOptions(modeledProductOptions, true),
    déchets: formatSearchBarOptions(déchets),
    fichesconfig: formatSearchBarOptions(configuredSheetOptions, true),
  };

  return searchBarOptions;
};

const formatSearchBarOptions = (options, withoutHtmlTitle = false) => {
  const formattedOptions = options
    .map((option) => ({
      ...option,
      title: withoutHtmlTitle ? option.name : (
    <div className="alignVerticalBlocks">
          <span>{option.name}</span>
          {option.description && (
            <Tooltip
              placement="top"
              title={
                <div
                  className="tooltip-description-innerHTML"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(option.description),
                  }}
                />
              }
            >
              <InfoIcon
                className="hoverBlue"
                style={{ color: '#a0aed3', marginLeft: '10px' }}
              />
            </Tooltip>
          )}
        </div>
        ),
      key: option.id,
      value: option.id,
    }))
    .filter(
      (elem, index, self) => index === self.findIndex((t) => t.name === elem.name)
    );

  return formattedOptions;
};

export const isProjectSingleZoneOnly = (projectZones, ignorPlotZone = false) => {
  const numberOfZones = projectZones.filter((zone) => zone.type === 'zone').length;

  if (ignorPlotZone) {
    return numberOfZones === 1;
  }

  const projectHasPlot = projectZones.some((zone) => zone.type === 'plot');

  return numberOfZones === 1 && !projectHasPlot;
};

export const isPlotInProject = (zones) => {
  const projectHasPlot = Boolean(
    zones.find((zone) => zone.type === ZONE_TYPES.plot)
  );

  return projectHasPlot;
};

export const isBuildingMonoZoneOnly = (buildingId, projectZones) => {
  const numberOfChildZones = projectZones.filter(
    (zone) => zone.ParentId === buildingId
  ).length;

  return numberOfChildZones === 1;
};

export const isBuildingSiteAValidDestination = (projectZones) => {
  const buildingSiteIsAValidDestination = projectZones.some(
    (zone) =>
      zone.type === 'buildingSite' &&
      zone.ProjectSheets.some((sheet) => sheet.source !== 'buildingSiteCalculator')
  );

  return buildingSiteIsAValidDestination;
};

export const getCertificationKeyNode = (currentAllotmentId) => {
  const certificationKeyNode =
    currentAllotmentId === ALLOTMENT_IDS.RE2020
      ? 'Re2020AllotmentNodeId'
      : currentAllotmentId === ALLOTMENT_IDS.EPCM
      ? 'EpcmAllotmentNodeId'
      : '';

  return certificationKeyNode;
};

export const getFlatContributorListTableData = (data) => {
  let flatDataTable = [];

  data.forEach((dataRow) => {
    if (dataRow.children && dataRow.children.length > 0) {
      flatDataTable = flatDataTable.concat(
        getFlatContributorListTableData(dataRow.children)
      );
    } else {
      flatDataTable.push(dataRow);
    }
  });

  return flatDataTable;
};

export const filterNodesByEnergyMatchingCurrentAllotment = (
  currentAllotmentId,
  allotmentNodes
) => {
  const isNodeValid = (allotmentNode) => {
    const isCombustionNode = allotmentNode.name.includes('Combustion');
    const isElectricityConsumption = allotmentNode.name.includes(
      "Consommation d'électricité"
    );

    if (!isCombustionNode && !isElectricityConsumption) {
      return true;
    }

    const wordNotAllowed =
      currentAllotmentId === ALLOTMENT_IDS.RE2020 ||
      currentAllotmentId === ALLOTMENT_IDS.NOOCO
        ? 'E+C-'
        : 'RE2020';

    return !allotmentNode.name.includes(wordNotAllowed);
  };

  return allotmentNodes.filter(isNodeValid);
};

export const getBbcaTreatmentModeId = (bbcaTreatmentModeName) => {
  if (!bbcaTreatmentModeName) {
    return null;
  }

  const treatmentModeKey = Object.keys(BBCA_TREATMENT_MODE_VALUES_NAME).find(
    (key) => BBCA_TREATMENT_MODE_VALUES_NAME[key] === bbcaTreatmentModeName
  );

  if (!treatmentModeKey) {
    return null;
  }

  return BBCA_TREATMENT_MODE_VALUES_KEY[treatmentModeKey];
};

export const filterSousLotByTypeOfNodes = (sousLot, typeOfNode) => {
  let conditionFilter =
    typeOfNode === OptionType.EQUIPMENTS
      ? (obj) => /^\d/.test(obj.name)
      : typeOfNode === OptionType.WATER
      ? (obj) => !/^\d/.test(obj.name) && obj.name.includes('Eau')
      : (obj) => !/^\d/.test(obj.name) && !obj.name.includes('Eau');

  return sousLot.filter(conditionFilter);
};
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const returnFormatProvider = (provider) => {
  if (provider === GOOGLE_PROVIDER) {
    return {
      provider: provider,
    };
  } else
    return {
      custom: provider,
    };
};

export const downloadFileOnS3 = async (key) => {
  try {
    const { body, eTag } = await downloadData({
      key,
    }).result;

    return body;
  } catch (error) {
    throw error;
  }

};


export const  truncateName = (name, limit) => {
  if (name.length > limit) {
    return <Tooltip title={name}>
      <span>{name.substring(0, limit) + '...'}</span>
    </Tooltip>
  } else {
    return name;
  }
}

let waterOrEnergyNodes = ['energie', 'eau'];

export const returnDefaultValueForSearchGroupSelectType = (importRow, allGroups) => {
  let nodeNooco = importRow.AllotmentNode || importRow.AllotmentNodeNooco;
  let potentialSheet = importRow.Sheet || importRow;

  let parentNodeName = findParentNode(
    nodeNooco,
    allGroups.flatAllotments,
    [],
    []
  )[0].name?.split(' ')[0];


  return potentialSheet && potentialSheet.type_fiche === TYPE_FICHE.BUNDLE
    ? SEARCH_GROUP_OPTION_VALUES.ENSEMBLES :
    potentialSheet && potentialSheet.type_fiche === TYPE_FICHE.FICHES_CONFIG ?
    SEARCH_GROUP_OPTION_VALUES.FICHESCONFIG :
    potentialSheet && potentialSheet.type_fiche === TYPE_FICHE.CUSTOM_USER ?
    SEARCH_GROUP_OPTION_VALUES.PRODUITS
    : nodeNooco &&
      waterOrEnergyNodes.includes(parentNodeName.toLowerCase())
    ? parentNodeName
    : (importRow.SheetId || importRow.id_inies)
    ? SEARCH_GROUP_OPTION_VALUES.INIES
    : !nodeNooco
    ? null
    : SEARCH_GROUP_OPTION_VALUES.EQUIPEMENTS;
};

